(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var follow = function follow() {
  var csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
  var followCreator = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(event, follow, creatorId) {
      var response, result, isProfile, parentDiv, showButton, kebabUnFollowButton, isUpdate;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetch("".concat(URL_BASE, "/follow"), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken
              },
              body: JSON.stringify({
                creator_id: creatorId,
                follow: follow
              })
            });
          case 3:
            response = _context.sent;
            if (response.ok) {
              _context.next = 7;
              break;
            }
            showModal('OOPS!!!', 'Failed to follow creator.', event);
            throw new Error('Failed to follow creator');
          case 7:
            _context.next = 9;
            return response.json();
          case 9:
            result = _context.sent;
            updateFcList(result.follow, creatorId);
            isProfile = event.target.getAttribute('data-isprofile');
            if (isProfile == "yes") {
              parentDiv = event.target.closest('div');
              showButton = event.target.classList.contains('un-follow') ? '.follow' : '.un-follow';
              kebabUnFollowButton = document.querySelector('.unfollow-btn.unfollow-icon');
              if (kebabUnFollowButton) {
                if (event.target.classList.contains('un-follow')) {
                  kebabUnFollowButton.classList.add('hide');
                }
              }
              updateFollowIcons(creatorId, follow);
              updateButtonStates(follow, creatorId, isProfile);
            }
            isUpdate = event.target.getAttribute('data-isUpdate');
            if (isUpdate === "yes") {
              updateFollowIcons(creatorId, follow);
              updateButtonStates(follow, creatorId, isProfile);
            }
            return _context.abrupt("return", result);
          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](0);
            console.error('Error following creator:', _context.t0);
          case 21:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 18]]);
    }));
    return function followCreator(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
  var showModal = function showModal(header, body, event) {
    document.querySelector('#jsModal .header').innerHTML = header;
    document.querySelector('#jsModal .body').innerHTML = "".concat(body);
    window.openModal('jsModal', event);
  };
  var updateFcList = function updateFcList(follow, creatorId) {
    creatorId = parseInt(creatorId);
    if (fc && Array.isArray(fc)) {
      if (follow === '1') {
        if (!fc.includes(creatorId)) {
          fc.push(creatorId);
        }
      } else {
        var index = fc.indexOf(creatorId);
        if (index !== -1) {
          fc.splice(index, 1);
        }
      }
    }
  };
  var updateFollowIcons = function updateFollowIcons(creatorId, follow) {
    var followIconsForUser = document.querySelectorAll(".prof-follow-icon.follow[data-id=\"".concat(creatorId, "\"]"));
    var unfollowIconsForUser = document.querySelectorAll(".prof-follow-icon.un-follow[data-id=\"".concat(creatorId, "\"]"));
    var updateKebab = document.querySelector("#kebabListModal .unfollow-btn[data-id=\"".concat(creatorId, "\"]"));
    var prfShareUnfollowBtn = document.querySelector(".prf-share .unfollow-icon[data-user=\"".concat(creatorId, "\"]"));
    if (follow === '1') {
      followIconsForUser.forEach(function (icon) {
        return icon.classList.add('hide');
      });
      unfollowIconsForUser.forEach(function (icon) {
        return icon.classList.remove('hide');
      });
      if (updateKebab) {
        updateKebab.classList.remove('hide');
      }
    } else {
      followIconsForUser.forEach(function (icon) {
        return icon.classList.remove('hide');
      });
      unfollowIconsForUser.forEach(function (icon) {
        return icon.classList.add('hide');
      });
      if (updateKebab) {
        updateKebab.classList.add('hide');
      }
    }
  };
  var updateButtonStates = function updateButtonStates(follow, creatorId, isProfile) {
    document.querySelectorAll(".flw-".concat(creatorId)).forEach(function (btn) {
      if (follow === '1') {
        btn.textContent = 'Following';
        btn.classList.replace('pri-btn', 'sel-btn');
        if (isProfile === 'yes') {
          var suggestedUsers = document.querySelector('.new-suggested-users');
          if (suggestedUsers && suggestedUsers.style.display === 'none') suggestedUsers.style.display = 'block';
        }
      } else {
        btn.textContent = 'Follow';
        btn.classList.replace('sel-btn', 'pri-btn');
      }
    });
    updateFollowIcons(creatorId, follow);
  };
  var handleFollowButtonClick = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(event, button) {
      var creatorId, followState, isProfile, result;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            event.preventDefault();
            creatorId = button.dataset.id;
            followState = button.textContent.trim() === 'Follow' ? "1" : "0";
            isProfile = button.dataset.isprofile;
            _context2.next = 6;
            return followCreator(event, followState, creatorId);
          case 6:
            result = _context2.sent;
            if (result) updateButtonStates(result.follow, creatorId, isProfile);
          case 8:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleFollowButtonClick(_x4, _x5) {
      return _ref2.apply(this, arguments);
    };
  }();
  document.addEventListener('mouseover', function (event) {
    var target = event.target;
    if (target.nodeType === 1 && target.matches('.follow-btn')) {
      if (target.textContent.trim() === 'Following') {
        target.textContent = 'Unfollow';
        target.classList.replace('sel-btn', 'pri-btn');
      }
    }
  });
  document.addEventListener('mouseout', function (event) {
    var target = event.target;
    if (target.nodeType === 1 && target.matches('.follow-btn')) {
      if (target.textContent.trim() === 'Unfollow') {
        target.textContent = 'Following';
        target.classList.replace('pri-btn', 'sel-btn');
      }
    }
  });
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (target.nodeType === 1 && target.matches('.follow-btn')) {
      handleFollowButtonClick(event, target);
    }
  });
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (target.nodeType === 1 && target.matches('.prof-follow-icon')) {
      event.preventDefault();
      var _follow = target.classList.contains('un-follow') ? "0" : "1";
      var creatorId = target.dataset.id;
      var isProfile = target.dataset.isprofile;
      followCreator(event, _follow, creatorId).then(function (result) {
        if (result) {
          updateFollowIcons(creatorId, _follow);
          target.classList.add('hide');
        }
      });
    }
  });
  document.querySelectorAll('.follow-btn').forEach(function (button) {
    button.classList.add(button.textContent.trim() === 'Follow' ? 'pri-btn' : 'sel-btn');
  });
};
module.exports = follow;

},{}],2:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var layout = function layout() {
  //Hamburger expand in mobile and desktop
  var hamburgers = document.querySelectorAll('.ham');
  var mob = document.querySelectorAll('.mob-ham');
  var desk = document.querySelectorAll('.desk');
  var desktop = document.querySelectorAll('.desktop-ham');
  var loginPopup = document.querySelectorAll('.login-signup');
  var nav = document.querySelector('nav');
  var createButton = document.querySelector('.create-btn');
  var mobOpen = false;
  var deskOpen = false;
  window.addEventListener('error', function (errorEvent) {
    var errorDetails = {
      message: errorEvent.message,
      url: errorEvent.filename,
      line: errorEvent.lineno,
      column: errorEvent.colno,
      stack: errorEvent.error.stack
    };

    // Send error details to Laravel backend
    fetch("".concat(URL_BASE, "/api/log/javascript-error"), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(errorDetails)
    });
  });
  var toggleVisibility = function toggleVisibility() {
    hamburgers.forEach(function (item) {
      item.classList.toggle('hide');
    });
    loginPopup.forEach(function (item) {
      item.classList.toggle('hide');
    });
    mob.forEach(function (item) {
      if (mobOpen) {
        item.classList.remove('show');
        item.classList.add('hide-tgl');
        item.addEventListener('animationend', function () {
          item.style.display = 'none';
        }, {
          once: true
        });
      } else {
        item.classList.remove('hide-tgl');
        item.classList.add('show');
        item.style.display = 'block';
      }
      mobOpen = !mobOpen;
    });
  };
  var toggleVisibile = function toggleVisibile() {
    desktop.forEach(function (item) {
      if (deskOpen) {
        item.classList.remove('show');
        item.classList.add('hide-tgl');
        item.addEventListener('animationend', function () {
          item.style.display = 'none';
          nav.style.width = 'auto';
        }, {
          once: true
        });
      } else {
        item.classList.remove('hide-tgl');
        item.classList.add('show');
        item.style.display = 'block';
        nav.style.width = '300px';
      }
      deskOpen = !deskOpen;
    });
  };
  var hideVisible = function hideVisible() {
    if (deskOpen) {
      desktop.forEach(function (item) {
        item.classList.remove('show');
        item.classList.add('hide-tgl');
        item.addEventListener('animationend', function () {
          item.style.display = 'none';
          nav.style.width = 'auto';
        }, {
          once: true
        });
      });
      deskOpen = false;
    }
    if (mobOpen) {
      mob.forEach(function (item) {
        item.classList.add('hide-tgl');
      });
      hamburgers.forEach(function (item) {
        item.classList.toggle('hide');
      });
      mobOpen = false;
    }
  };

  // Add click event listener to each hamburger element
  hamburgers.forEach(function (ele) {
    ele.addEventListener('click', toggleVisibility);
  });
  desk.forEach(function (ele) {
    ele.addEventListener('click', toggleVisibile);
  });

  // Add click event listener for hide
  document.addEventListener('click', function (event) {
    if (!event.target.closest('.desk') && !event.target.closest('.desktop-ham') && deskOpen) {
      hideVisible();
    }
    if (!event.target.closest('.ham') && !event.target.closest('.mob-ham') && mobOpen) {
      hideVisible();
    }
  });

  // web app install
  var appInstall = document.getElementById('appInstall');
  var deferredPrompt;
  window.addEventListener('beforeinstallprompt', function (e) {
    // Prevent the mini-infobar from appearing on mobile
    e.preventDefault();
    // Stash the event so it can be triggered later.
    deferredPrompt = e;
    // Optionally, send analytics event that PWA install promo was shown.
    console.log("'beforeinstallprompt' event was fired.");
  });
  function showInstallPrompt() {
    return _showInstallPrompt.apply(this, arguments);
  }
  function _showInstallPrompt() {
    _showInstallPrompt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _yield$deferredPrompt, outcome;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (deferredPrompt) {
              _context2.next = 3;
              break;
            }
            alert("Installed App Already!!!");
            return _context2.abrupt("return", false);
          case 3:
            deferredPrompt.prompt();

            // Wait for the user to respond to the prompt
            _context2.next = 6;
            return deferredPrompt.userChoice;
          case 6:
            _yield$deferredPrompt = _context2.sent;
            outcome = _yield$deferredPrompt.outcome;
            // Optionally, send analytics event with outcome of user choice
            console.log("User response to the install prompt: ".concat(outcome));

            // We've used the prompt, and can't use it again, throw it away
            deferredPrompt = null;
          case 10:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _showInstallPrompt.apply(this, arguments);
  }
  if (appInstall) {
    appInstall.addEventListener('click', showInstallPrompt);
  }

  //privacy expand
  var priExpand = document.querySelectorAll('.pri-exp');
  var privacy = document.querySelectorAll('.privacy');
  var toggle = function toggle() {
    privacy.forEach(function (item) {
      item.classList.toggle('hide');
    });
  };
  priExpand.forEach(function (ele) {
    ele.addEventListener('click', toggle);
  });

  //About expand
  var abtExpand = document.querySelectorAll('.abt-exp');
  var about = document.querySelectorAll('.about');
  var aboutToggle = function aboutToggle() {
    about.forEach(function (item) {
      item.classList.toggle('hide');
    });
  };
  abtExpand.forEach(function (ele) {
    ele.addEventListener('click', aboutToggle);
  });

  //Ticket expand
  var ticketExpand = document.querySelectorAll('.ticket-exp');
  var ticket = document.querySelectorAll('.ticket');
  var ticketToggle = function ticketToggle() {
    ticket.forEach(function (item) {
      item.classList.toggle('hide');
    });
  };
  ticketExpand.forEach(function (ele) {
    ele.addEventListener('click', ticketToggle);
  });

  //payment expand
  var payExpand = document.querySelectorAll('.pay-exp');
  var pay = document.querySelectorAll('.pay');
  var hideAndVisible = function hideAndVisible() {
    pay.forEach(function (item) {
      item.classList.toggle('hide');
    });
  };
  payExpand.forEach(function (ele) {
    ele.addEventListener('click', hideAndVisible);
  });
  var closeModal = function closeModal(ele) {
    var element = document.querySelector("#".concat(ele));
    if (!element) {
      return false;
    }
    var form = element.querySelector('form');
    if (form) {
      form.reset();
    }
    element.removeAttribute('id-open');
    element.style.display = 'none';
    document.getElementById('overlay').style.display = 'none';
    document.querySelector('body').style.overflow = 'auto';
  };
  var closeModalHandler = function closeModalHandler() {
    document.querySelectorAll('.modal-container').forEach(function (ele) {
      var form = ele.querySelector('form');
      if (form) {
        form.reset();
      }
      ele.removeAttribute('id-open');
      ele.style.display = 'none';

      // Restore href attributes in links inside the modal
      var links = ele.querySelectorAll('a');
      links.forEach(function (link) {
        var originalHref = link.getAttribute('href');
        if (originalHref && originalHref.includes("/post/")) {
          var baseHref = originalHref.split('?')[0];
          link.setAttribute('href', baseHref);
        }
      });
    });

    // Adjust copy_link value to remove /post/${responseId}
    var copy_link = document.querySelector('#copy_post_link');
    if (copy_link) {
      copy_link.value = '';
    }
    document.getElementById('overlay').style.display = 'none';
    document.querySelector('body').style.overflow = 'auto';

    // Check if createButton has a disabled attribute and remove it
    if (createButton && createButton.hasAttribute('disabled')) {
      createButton.removeAttribute('disabled');
      createButton.classList.remove('disabled');
    }
  };
  var overlays = document.getElementById('overlay');
  if (overlays) {
    overlays.addEventListener('click', closeModalHandler);
  }
  document.querySelectorAll('.modal-container, .modal-container .close, .modal-container .cancel').forEach(function (element) {
    element.addEventListener('click', function (e) {
      if (e.currentTarget !== e.target) {
        return;
      }
      e.preventDefault();
      closeModalHandler();
    });
  });
  var showFormError = function showFormError(errors, parentEl) {
    var error = '';
    for (var key in errors) {
      if (errors.hasOwnProperty(key)) {
        error += '<li>' + errors[key] + '</li>';
      }
    }
    parentEl.querySelector('.showFormErrors').innerHTML = error;
    parentEl.querySelector('.formError').style.setProperty('display', 'block', 'important');
  };
  var openModal = function openModal(id, event) {
    var overlay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var ele = document.getElementById(id);
    if (!ele) {
      return false;
    }
    ele.setAttribute('id-open', true);
    var wallet = ele.querySelector('#walletAmount');
    if (wallet) {
      wallet.innerHTML = walletAmount;
    }
    ele.style.display = 'flex';
    if (overlay) {
      document.getElementById('overlay').style.display = 'block';
      document.querySelector('body').style.overflow = 'hidden';
    }
    // if (window.innerWidth >=768) {
    //     const x = event.clientX;
    //     const y = event.clientY;

    //     ele.style.left = x + 'px';
    //     ele.style.top = y + 'px';
    //     // ele.style.display = 'block';

    //     console.log(event.clientX)
    //     console.log(event.clientY)
    // }
  };
  var copyToClipboard = function copyToClipboard(text) {
    if (navigator.clipboard && window.isSecureContext) {
      // Use the Clipboard API if available and in a secure context
      navigator.clipboard.writeText(text).then(function () {})["catch"](function (err) {
        console.error('Failed to copy text: ', err);
      });
    } else {
      // Fallback to the older method
      var textarea = document.createElement('textarea');
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        console.log('Text copied to clipboard');
      } catch (err) {
        console.error('Failed to copy text: ', err);
      }
      document.body.removeChild(textarea);
    }
  };
  function isInViewport(element, offset) {
    var rect = element.getBoundingClientRect();
    return rect.top >= 0 - offset && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) + offset && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
  }
  function handleScroll() {
    var element = document.querySelector('.loadmore');
    if (!element) return;
    var dataload = element.getAttribute('data-load');
    if (dataload === "true" && isInViewport(element, 800)) {
      element.setAttribute('data-load', "false");
      element.click();
    }
  }
  document.addEventListener('scroll', handleScroll);
  var main = document.querySelector('main');
  if (main) {
    main.addEventListener('scroll', handleScroll);
  }
  var replaceSrc = function replaceSrc(element, isAdded) {
    if (element.tagName.toLowerCase() === 'img') {
      var currentSrc = element.getAttribute('src');
      var newSrc = isAdded ? currentSrc.replace('.svg', '-filled.svg') : currentSrc.replace('-filled.svg', '.svg');
      element.setAttribute('src', newSrc);
    }
  };

  //loadmore notifications
  var loadMores = function loadMores(e) {
    var loadMoreButton = e.target;
    var mainClassName = loadMoreButton.getAttribute('data-main');
    var subClass = loadMoreButton.getAttribute('data-sub');
    var mainElements = document.querySelectorAll(mainClassName);
    var lastMainElement = mainElements[mainElements.length - 1];
    var subElements = lastMainElement.querySelectorAll(subClass);
    var totalSubElements = 0;

    // Count all sub-elements when either 'firstFeed' or 'pinnedPost' is present in updates
    mainElements.forEach(function (mainElement) {
      totalSubElements += mainElement.querySelectorAll(subClass).length;
    });

    // set the skip value based on the counts
    var skip = totalSubElements > subElements.length ? totalSubElements : subElements.length;
    var href = loadMoreButton.getAttribute('data-href') + '&skip=' + skip;

    // get the total in href
    var totalMatch = href.match(/total=(\d+)/);
    var total = totalMatch ? parseInt(totalMatch[1], 10) : null;
    if (loadMoreButton) {
      fetch(href, {
        method: 'GET',
        headers: {
          'Accept': 'application/xml',
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then(function (response) {
        return response.text();
      }).then(function (data) {
        if (!data) {
          loadMoreButton.classList.add('disabled', 'hide');
        }
        if (data && data !== "session_timeout") {
          var tempContainer = document.createElement('div');
          tempContainer.innerHTML = data;
          if (tempContainer.firstChild && tempContainer.firstChild.nodeName && tempContainer.firstChild.nodeName.toLowerCase() === 'div') {
            while (tempContainer.firstChild) {
              lastMainElement.appendChild(tempContainer.firstChild);
            }
            skip = lastMainElement.querySelectorAll(subClass).length;
            loadMore.setAttribute('data-load', "true");
          } else {
            loadMore.parentNode.removeChild(loadMore);
          }
          if (total <= skip) {
            loadMore.parentNode.removeChild(loadMore);
          }
        }
      })["catch"](function (error) {
        console.error('Error fetching data:', error);
      });
    }
  };
  var loadMore = document.querySelector('.loadmore');
  if (loadMore) {
    loadMore.addEventListener('click', loadMores);
  }

  //unfollow handler
  var unfollowHandler = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
      var unfollowBtn, creatorId, profFollowIcon, response, data, allButtons, index, errorData;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            e.preventDefault();
            unfollowBtn = document.querySelector('.unfollow-btn');
            creatorId = unfollowBtn.getAttribute("data-user");
            profFollowIcon = document.querySelector('.prof-follow-icon');
            _context.prev = 4;
            _context.next = 7;
            return fetch("".concat(URL_BASE, "/follow"), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
              },
              body: JSON.stringify({
                creator_id: creatorId,
                follow: "0"
              })
            });
          case 7:
            response = _context.sent;
            if (!response.ok) {
              _context.next = 20;
              break;
            }
            _context.next = 11;
            return response.json();
          case 11:
            data = _context.sent;
            document.querySelector('#jsModal .header').innerHTML = 'Success!!';
            document.querySelector('#jsModal .body').innerHTML = 'You unfollowed this creator';
            // Update all buttons with the same creator ID
            allButtons = document.querySelectorAll(".f-".concat(creatorId));
            allButtons.forEach(function (btn) {
              btn.textContent = 'Follow';
              btn.classList.add('pri-btn');
              btn.classList.remove('sel-btn');
            });
            index = fc.indexOf(parseInt(creatorId));
            if (index !== -1) {
              fc.splice(index, 1);
              if (profFollowIcon) {
                profFollowIcon.classList.toggle('hide');
              }
            }
            _context.next = 25;
            break;
          case 20:
            _context.next = 22;
            return response.json();
          case 22:
            errorData = _context.sent;
            document.querySelector('#jsModal .header').innerHTML = 'Failed!!';
            document.querySelector('#jsModal .body').innerHTML = '<br><br>Failed to unfollowed this creator';
          case 25:
            window.closeModal('kebabListModal');
            window.closeModal('messageListModal');
            window.closeModal('notificationListModal', e);
            window.openModal('jsModal', e);
            _context.next = 34;
            break;
          case 31:
            _context.prev = 31;
            _context.t0 = _context["catch"](4);
            console.log(_context.t0);
          case 34:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[4, 31]]);
    }));
    return function unfollowHandler(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  window['showFormError'] = showFormError;
  window['openModal'] = openModal;
  window['closeModal'] = closeModal;
  window['copyToClipboard'] = copyToClipboard;
  window['replaceSrc'] = replaceSrc;
  window['loadmores'] = loadMores;
  window['unfollowHandler'] = unfollowHandler;
  if (SOCKET_URL) {
    window['socket'] = io.connect(SOCKET_URL, {
      withCredentials: true
    });
    window['socket'].on('connect', function () {
      var activeStatusOnline = document.querySelectorAll(".active-status-online");
      if (activeStatusOnline.length > 0) {
        var userIds = Array.from(activeStatusOnline).map(function (element) {
          return element.getAttribute('data-user-id');
        });
        socket.emit('usersActiveStatus', userIds, function (response) {
          console.log("Server response for usersActiveStatus:", response);
        });
      }
    });
    window['socket'].on('error', function (error) {
      console.error('Socket error:', error);
    });
  }
  // Cookies
  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000); // Convert days to milliseconds
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }
  function getCookie(name) {
    var nameEQ = name + "=";
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i].trim(); // Trim leading spaces
      if (cookie.indexOf(nameEQ) === 0) return cookie.substring(nameEQ.length, cookie.length);
    }
    return null;
  }
  var cookieOverlay = document.getElementById('overlay-cookie');
  var overlay = document.getElementById('overlay');
  var body = document.querySelector('body');
  function showOverlay() {
    if (alertAdultModal || cookieConsentModal) {
      cookieOverlay.style.display = 'block';
      overlay.style.display = 'none';
      body.classList.add('overflow-hidden');
    }
  }
  function closeOverlay() {
    if (cookieConsentModal) {
      cookieOverlay.style.display = 'none';
      body.classList.remove('overflow-hidden');
    }
  }
  var alertAdultModal = document.querySelector('#alertAdult');
  var btnAlertAdult = document.querySelector('#btnAlertAdult');
  if (alert_adult && !getCookie('alertAdult')) {
    window.openModal('alertAdult');
    overlay.style.display = 'none';
    showOverlay();
  }
  if (btnAlertAdult) {
    btnAlertAdult.addEventListener('click', function () {
      setCookie('alertAdult', true, 365);
      if (alertAdultModal && getCookie('alertAdult')) {
        window.closeModal('alertAdult');
        closeOverlay();
      }
    });
  }
  var cookieConsentModal = document.querySelector('#cookieConsentModal');
  var btnCloseCookieConsent = document.querySelector('#btnCloseCookieConsent');
  if (cookie_consent && !getCookie('cookiePolicy')) {
    window.openModal('cookieConsentModal');
    overlay.style.display = 'none';
  }
  if (btnCloseCookieConsent) {
    btnCloseCookieConsent.addEventListener('click', function () {
      setCookie('cookiePolicy', true, 365);
      if (cookieConsentModal && getCookie('cookiePolicy')) {
        window.closeModal('cookieConsentModal');
      }
    });
  }

  //share the live event to the BroadCast message
  var broadcastLink = document.getElementById('broadcastLink');
  var messageTextarea = document.querySelector('.broadcast-msg');
  var replyButton = document.getElementById('button-reply-msg');
  if (broadcastLink) {
    broadcastLink.addEventListener('click', function (event) {
      event.preventDefault();
      var liveMessage = broadcastLink.getAttribute('data-message');
      window.location.href = broadcastLink.href + '?message=' + encodeURIComponent(liveMessage);
    });
  }
  if (messageTextarea) {
    var urlParams = new URLSearchParams(window.location.search);
    var message = decodeURIComponent(urlParams.get('message') || ''); //If qrystring message is null, empty string will be assigned
    if (message.trim()) {
      replyButton.classList.remove('disabled');
      replyButton.style.opacity = "1";
      messageTextarea.value = message;
    }
  }
  var socket = window.socket;
  if (socket) {
    //When user is offline or login issue during Login-validation in Socketcontroller of socket server, Redirect to Login page
    socket.on('login-error', function (data) {
      console.log('Socket Login-error');
    });
  }

  // Live Streaming Time Conversion
  var liveTimeElems = document.querySelectorAll('.jsliveTime');
  if (liveTimeElems) {
    liveTimeElems.forEach(function (liveTimeEle) {
      if (liveTimeEle && liveTimeEle.innerHTML) {
        var _liveTimeEle$innerHTM = liveTimeEle.innerHTML.split(' '),
          _liveTimeEle$innerHTM2 = _slicedToArray(_liveTimeEle$innerHTM, 2),
          scheduleDate = _liveTimeEle$innerHTM2[0],
          scheduleTime = _liveTimeEle$innerHTM2[1];
        if (scheduleTime) {
          var _scheduleTime$split = scheduleTime.split(':'),
            _scheduleTime$split2 = _slicedToArray(_scheduleTime$split, 3),
            scHour = _scheduleTime$split2[0],
            scMin = _scheduleTime$split2[1],
            scSec = _scheduleTime$split2[2];
          var d = new Date();
          d.setUTCHours(scHour, scMin, scSec, 0);

          // Format the local time in 12-hour format without seconds
          var localTimeString = d.toLocaleTimeString("en-IN", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true
          });

          // Update the innerHTML with the local time string, replacing am/pm with AM/PM
          liveTimeEle.innerHTML = localTimeString.replace('am', 'AM').replace('pm', 'PM');
        }
      }
    });
  }

  // If the creator refresh the page, then display the active vcModal
  var videoCallAlertModal = document.getElementById('videoCallAlertModal');
  if (videoCallAlertModal) {
    // Get values from view services provider
    var creatorId = videoCallAlertModal.querySelector('#crId').value;
    var userId = videoCallAlertModal.querySelector('#userId').value;
    var authUserId = videoCallAlertModal.querySelector('#authUser').value;
    var vcRoomId = videoCallAlertModal.querySelector('#roomId').value;
    var answerBtn = videoCallAlertModal.querySelector('#answer-btn');
    var rejectBtn = videoCallAlertModal.querySelector('#reject-btn');
    var snoozeBtn = videoCallAlertModal.querySelector('#snooze-btn');
    var snoozeDropdown = document.getElementById('snooze-dropdown');
    var snoozeDurations = document.querySelectorAll('.snooze-duration');
    var offVcAlertSound = document.getElementById('stopPlayBack').value;
    var showNotifyAlert = videoCallAlertModal.querySelector('#notifyAlert').value;
    window.addEventListener("load", function () {
      // If the video call is ongoing and the authenticated user is the creator
      if (creatorId == authUserId && vcRoomId && showNotifyAlert === 'yes') {
        videoCallAlertModal.classList.remove('hide'); // Show the modal
        // If the user is snooze the video call then stop the ringtone sound
        if (offVcAlertSound == 1) {
          snoozeBtn.classList.add('hide');
        }
      }
    });
    if (answerBtn && rejectBtn && snoozeBtn) {
      // Handle answer button click
      answerBtn.addEventListener('click', function (e) {
        e.preventDefault();
        // Get values from data attribute
        var roomId = videoCallAlertModal.getAttribute('data-room-id');
        roomId = roomId || vcRoomId;
        var url = "".concat(URL_BASE, "/video/call/").concat(authUserId, "/").concat(roomId);
        console.log('Answer button clicked');
        videoCallAlertModal.classList.add('hide');
        window.location.href = url;
      });

      // Handle reject button click
      rejectBtn.addEventListener('click', function () {
        // Get values from data attribute
        var callerId = videoCallAlertModal.getAttribute('data-caller-id');
        var roomId = videoCallAlertModal.getAttribute('data-room-id');
        callerId = callerId || userId;
        roomId = roomId || vcRoomId;
        console.log('Reject button clicked');
        socket.emit('reject-call', {
          userId: callerId,
          recipientId: creatorId,
          roomId: roomId
        });
        videoCallAlertModal.classList.add('hide');
      });

      // Toggle dropdown visibility on button click
      if (snoozeBtn) {
        snoozeBtn.addEventListener('click', function (e) {
          e.preventDefault();
          // Toggle the 'hide' class
          snoozeDropdown.classList.toggle('hide');
        });
      }

      // Close the dropdown if clicking outside
      document.addEventListener('click', function (e) {
        if (!snoozeBtn.contains(e.target) && !snoozeDropdown.contains(e.target)) {
          snoozeDropdown.classList.add('hide');
        }
      });

      // Handle snooze button click
      snoozeDurations.forEach(function (snoozeDuration) {
        snoozeDuration.addEventListener('click', function () {
          // Get values from data attribute
          var roomId = videoCallAlertModal.getAttribute('data-room-id');
          var snoozeTime = snoozeDuration.dataset.duration;
          roomId = roomId || vcRoomId;
          console.log('snooze button clicked');
          fetch("/videocall/snooze/".concat(creatorId, "/").concat(roomId), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            },
            body: JSON.stringify({
              snoozeTime: snoozeTime
            })
          }).then(function (response) {
            return response.json();
          }).then(function (data) {
            if (data) {
              socket.emit('snooze-call', {
                recipientId: creatorId
              });
            }
          })["catch"](function (error) {
            console.error('Error fetching data:', error);
          })["finally"](function () {
            snoozeDropdown.classList.add('hide');
          });
        });
      });
    }
  }
  var audioContext = new (window.AudioContext || window.webkitAudioContext)();
  var source;
  if (socket) {
    // Function to close the videoCallAlertModal if the recipientId matches
    var closeVideoCallAlertModal = function closeVideoCallAlertModal(recipientId) {
      var videoCallAlertModal = document.getElementById('videoCallAlertModal');
      if (videoCallAlertModal) {
        var _authUserId2 = videoCallAlertModal.querySelector('#crId').value;
        if (_authUserId2 == recipientId) {
          videoCallAlertModal.classList.add('hide');
        }
        // const receiverTone = videoCallAlertModal.querySelector('#receiver-tone');
        // receiverTone.pause();
        // receiverTone.currentTime = 0;
        if (source) {
          source.stop(); // Stop playback
          source = null; // Clear the source to prevent re-stopping
        }
      }
    }; // If creator didn't accept the call
    socket.on('receive-call', function (data) {
      if (data) {
        console.log('Incoming call from:', data.callerId);
        var _videoCallAlertModal = document.getElementById('videoCallAlertModal');
        _videoCallAlertModal.setAttribute('data-room-id', data.roomId);
        _videoCallAlertModal.setAttribute('data-caller-id', data.callerId);
        var userDetails = data.userDetails;
        var _offVcAlertSound = data.stopPlayback;
        var videoCallAlertOff = data.videoCallAlertOff;
        var _snoozeBtn = _videoCallAlertModal.querySelector('#snooze-btn');
        if (_videoCallAlertModal && !videoCallAlertOff) {
          // const receiverTone = videoCallAlertModal.querySelector('#receiver-tone');
          // receiverTone.pause();
          // receiverTone.currentTime = 0;
          // const ringtone = new Audio(receiverTone);
          // ringtone.loop = true;
          // ringtone.play();
          if (!source && !_offVcAlertSound) {
            fetch(receiverTone).then(function (response) {
              return response.arrayBuffer();
            }).then(function (buffer) {
              return audioContext.decodeAudioData(buffer);
            }).then(function (decodedData) {
              source = audioContext.createBufferSource();
              source.buffer = decodedData;
              source.loop = true;
              source.connect(audioContext.destination);
              source.start(0);
            })["catch"](function (error) {
              return console.log("Audio playback error:", error);
            });
          }
          // If the creator is snooze the video call then stop the ringtone sound
          if (_offVcAlertSound && _snoozeBtn) {
            _snoozeBtn.classList.add('hide');
          }
          _videoCallAlertModal.querySelector('#roomId').value = data.roomId;
          _videoCallAlertModal.querySelector('#userId').value = data.callerId;
          _videoCallAlertModal.querySelector('.caller-name').innerHTML = userDetails.name;
          var avatarElement = document.getElementById('callerAvatar');
          avatarElement.src = avatarBasePath + userDetails.avatar;
          var _authUserId = _videoCallAlertModal.querySelector('#crId').value;
          var url = "".concat(URL_BASE, "/video/call/").concat(_authUserId, "/").concat(data.roomId);
          _videoCallAlertModal.classList.remove('hide');
        }
      }
    });
    socket.on('call-not-connected', function (data) {
      closeVideoCallAlertModal(data.recipientId);
    });

    // Listen for 'close-alert-modal' event and close the modal
    socket.on('close-alert-modal', function (data) {
      closeVideoCallAlertModal(data.recipientId);
    });
  }
};
module.exports = layout;

},{}],3:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var livePermission = function livePermission() {
  var liveStreamingLink = document.querySelectorAll('.liveStreamingLink');
  if (liveStreamingLink) {
    liveStreamingLink.forEach(function (link) {
      link.addEventListener('click', /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(event) {
          var isScheduledLive, errorContainer, showFormErrors, checkPermission, permissionGranted, liveStreamingUrl;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                event.preventDefault();
                isScheduledLive = this.getAttribute('data-live');
                errorContainer = document.querySelector('.formError');
                showFormErrors = errorContainer.querySelector('.showFormErrors');
                if (errorContainer) {
                  errorContainer.style.display = 'none';
                  showFormErrors.innerHTML = '';
                }
                if (!(isScheduledLive && isScheduledLive === 'true')) {
                  _context2.next = 8;
                  break;
                }
                if (errorContainer) {
                  errorContainer.style.display = 'block';
                  showFormErrors.innerHTML = '<li>Only one live can be Scheduled at a time!!!</li>';
                }
                return _context2.abrupt("return");
              case 8:
                // Function to check for video/audio permissions
                checkPermission = /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
                    var stream;
                    return _regeneratorRuntime().wrap(function _callee$(_context) {
                      while (1) switch (_context.prev = _context.next) {
                        case 0:
                          _context.prev = 0;
                          _context.next = 3;
                          return navigator.mediaDevices.getUserMedia({
                            video: true,
                            audio: true
                          });
                        case 3:
                          stream = _context.sent;
                          // Stop all tracks after permission is granted
                          stream.getTracks().forEach(function (track) {
                            return track.stop();
                          });
                          return _context.abrupt("return", true);
                        case 8:
                          _context.prev = 8;
                          _context.t0 = _context["catch"](0);
                          console.error("Permissions denied or an error occurred: ", _context.t0);
                          return _context.abrupt("return", false);
                        case 12:
                        case "end":
                          return _context.stop();
                      }
                    }, _callee, null, [[0, 8]]);
                  }));
                  return function checkPermission() {
                    return _ref2.apply(this, arguments);
                  };
                }(); // Check for permissions
                _context2.next = 11;
                return checkPermission();
              case 11:
                permissionGranted = _context2.sent;
                liveStreamingUrl = link.dataset.url;
                if (permissionGranted) {
                  // If permission is granted, navigate to the live streaming form
                  window.location.href = liveStreamingUrl;
                } else {
                  // If permission is denied, show the modal
                  window.openModal('LivePermission');
                }
              case 14:
              case "end":
                return _context2.stop();
            }
          }, _callee2, this);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    });
  }
};
module.exports = livePermission;

},{}],4:[function(require,module,exports){
"use strict";

var liveStoryTimer = function liveStoryTimer() {
  function updateTimer() {
    var currentTime = new Date();
    document.querySelectorAll('.liveStory > ul > li').forEach(function (li) {
      var liveDateTimeString = li.getAttribute('data-live-datetime');
      if (liveDateTimeString) {
        var formattedDateTimeString = liveDateTimeString.replace(' ', 'T');
        var liveDateTime = new Date(formattedDateTimeString);
        var timerId = li.getAttribute('id').replace('story-live-', '');
        var timezoneOffset = liveDateTime.getTimezoneOffset();
        liveDateTime.setMinutes(liveDateTime.getMinutes() - timezoneOffset);
        var timerDiv = document.getElementById('timer-' + timerId);
        var timeDiff = liveDateTime.getTime() - currentTime.getTime();
        if (timeDiff <= 15 * 60 * 1000) {
          if (timerDiv) {
            timerDiv.classList.add('hide');
          }
          var livenow = document.querySelector('#story-live-' + timerId + ' .live-indicator');
          if (livenow) {
            livenow.classList.remove('hide');
          }
          // Remove 'outline' class from <li> if timer is hidden
          li.classList.add('outline');
        } else if (timeDiff <= 24 * 60 * 60 * 1000) {
          timeDiff += 1000;
          var hours = Math.floor(timeDiff / (1000 * 60 * 60));
          var minutes = Math.floor(timeDiff % (1000 * 60 * 60) / (1000 * 60));
          var seconds = Math.floor(timeDiff % (1000 * 60) / 1000);
          var formattedTime = (hours < 10 ? "0" : "") + hours + ":" + (minutes < 10 ? "0" : "") + minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
          if (timerDiv) {
            timerDiv.innerHTML = formattedTime;
            timerDiv.classList.remove('hide');
          }
        }
      }
    });
  }
  updateTimer();
  setInterval(updateTimer, 1000);
};
module.exports = liveStoryTimer;

},{}],5:[function(require,module,exports){
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var liveStoryForm = function liveStoryForm() {
  // Function to convert server time to local time
  function convertToLocalTime(serverTime) {
    var isoDateString = serverTime.replace(' ', 'T') + 'Z';
    var date = new Date(isoDateString);
    var optionsDate = {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    };
    var optionsTime = {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    };
    var dateString = date.toLocaleDateString(undefined, optionsDate);
    var timeString = date.toLocaleTimeString(undefined, optionsTime);
    return "".concat(dateString, ", ").concat(timeString);
  }

  // Add event listener to the list items
  var liveStoryItems = document.querySelectorAll('.liveStoryList .items');
  var processlivePrebook = function processlivePrebook(e) {
    e.preventDefault();
    var element = e.target;
    element.setAttribute('disabled', 'true');
    var icon = document.createElement('i');
    icon.classList.add('spinner');
    element.appendChild(icon);
    var liveStoryPopup = document.getElementById('liveStoryPopup');
    var liveID = document.getElementById('story-liveid').value;
    var btnName = element.textContent;
    var liveUrl = document.getElementById('formPayLiveStory').action;

    // Before 3mins of Live Start, Join Button will be displayed to redirect to Live
    if (btnName == 'Join Now' || btnName == 'Join for Free') {
      liveStoryPopup.style.display = 'none';
      window.location.href = liveUrl;
      return false;
    } else {
      var form = document.getElementById('formPayLiveStory');
      var formData = new FormData(form);
      var page = form.querySelector('.ref');
      fetch(form.action, {
        method: 'POST',
        body: formData
      }).then(function (response) {
        return response.json();
      }).then(function (result) {
        element.removeAttribute('disabled');
        element.removeChild(icon);
        if (result.url) {
          liveStoryPopup.style.display = 'none';
          window.location.href = result.url;
          return false;
        } else if (result.success) {
          updateWalletAmount(result.wallet);
          var idExist = document.querySelector(".story-live .story-live-".concat(liveID));
          if (idExist) {
            idExist.setAttribute('data-prebook', 'true');
            idExist.click();
            if (page) {
              if (page.value == 'profile') {
                setTimeout(function () {
                  window.location.reload();
                }, 600);
              }
            }
          }
        } else if (result.errors) {
          window.showFormError(result.errors, liveStoryPopup);
        }
      })["catch"](function (error) {
        var errors = {
          error: 'Error Occurred!!'
        };
        window.showFormError(errors, liveStoryPopup);
        console.error('Story Prebook Fetch error:', error);
        element.removeAttribute('disabled');
        element.removeChild(icon);
      });
    }
  };
  liveStoryItems.forEach(function (item) {
    item.addEventListener('click', function (e) {
      e.preventDefault();
      clearModalData();
      // Get the data attributes of the clicked live item
      var isPrebooked = item.getAttribute('data-prebook');
      var liveViewUser = item.getAttribute('data-live-view');
      var availability = item.getAttribute('data-availability');
      var isSubscribed = item.getAttribute('data-subscribed');
      var liveId = item.getAttribute('data-live-id');
      var liveChannel = item.getAttribute('data-live-channel');
      var userId = item.getAttribute('data-userid');
      var username = item.getAttribute('data-username');
      var name = item.getAttribute('data-name');
      var livename = item.getAttribute('data-live-name');
      var dateTime = item.getAttribute('data-live-datetime');
      var duration = item.getAttribute('data-live-duration');
      var price = item.getAttribute('data-live-price');
      var avatarUrl = item.querySelector('img').dataset.imgSrc;
      var prebookCount = item.getAttribute('data-prebook-count');
      var isCreatorJoined = item.getAttribute('data-creators-joined');
      var localDateTime = convertToLocalTime(dateTime);

      //pay_prebook
      var payLiveStoryBtn = document.getElementById('payLiveStoryBtn');
      if (payLiveStoryBtn) {
        payLiveStoryBtn.addEventListener('click', processlivePrebook);
      }
      if (!userId) {
        window.location.href = URL_BASE + '/login';
        return false;
      }
      var _dateTime$split = dateTime.split(' '),
        _dateTime$split2 = _slicedToArray(_dateTime$split, 2),
        scheduleDate = _dateTime$split2[0],
        scheduleTime = _dateTime$split2[1];
      var _scheduleDate$split = scheduleDate.split('-'),
        _scheduleDate$split2 = _slicedToArray(_scheduleDate$split, 3),
        schYear = _scheduleDate$split2[0],
        schMonth = _scheduleDate$split2[1],
        schDate = _scheduleDate$split2[2];
      var _scheduleTime$split = scheduleTime.split(':'),
        _scheduleTime$split2 = _slicedToArray(_scheduleTime$split, 2),
        scHour = _scheduleTime$split2[0],
        schMin = _scheduleTime$split2[1];
      var d = new Date(Date.UTC(schYear, schMonth - 1, schDate, scHour, schMin, 0));
      var dateString = d.toLocaleString("en-IN", {
        day: "numeric",
        month: "short",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit"
      });
      var currentDate = new Date();
      var currDt = new Date(Date.parse(currentDate));
      var liveDt = new Date(Date.parse(dateString));
      var liveLink = "".concat(URL_BASE, "/live/").concat(username);
      var creatorURL = "".concat(URL_BASE, "/").concat(username);
      var actionUrl;

      // To Calculate Time Left Before to Start Live
      var beforeLiveBuffer = liveDt.getTime() - currDt.getTime();
      var beforeLiveseconds = Math.floor(beforeLiveBuffer / 1000);
      var beforeLivetimeLeftMins = Math.floor(beforeLiveseconds / 60);
      if (isPrebooked || liveViewUser) {
        // To Enable Join button in Story Modal before 5minutes of Live Start Time
        if (beforeLivetimeLeftMins < 5) {
          document.getElementById('liveViewPermission').classList.remove('disabled');
          document.getElementById('liveViewPermission').classList.add('blk-btn');
          document.getElementById('liveViewPermission').classList.remove('disabled-btn');
        }
      } else {
        if (beforeLivetimeLeftMins < 5) {
          // To Calculate Time Left For Live to End
          if (currDt.getTime() >= liveDt.getTime()) {
            var timeDifference = currDt.getTime() - liveDt.getTime();
            var seconds = Math.floor(timeDifference / 1000);
            var timeLeftMinutes = Math.floor(seconds / 60);
            var timeLeft = duration - timeLeftMinutes;
            document.getElementById('liveStoryPopup').querySelector('.live-story-endsin').classList.remove('hide');
            document.getElementById('liveStoryPopup').querySelector('.live-story-endsin span').textContent = timeLeft + ' minutes';
            document.getElementById('liveViewPermission').classList.remove('disabled-btn');
          }
          document.getElementById('liveStoryPopup').querySelector('.live-story-price span').textContent = price;
          document.getElementById('payLiveStoryBtn').classList.add('hide');
          document.getElementById('liveViewPermission').classList.remove('hide');
          document.getElementById('liveViewPermission').classList.remove('disabled');
          document.getElementById('liveViewPermission').classList.add('blk-btn');
          document.getElementById('liveViewPermission').setAttribute('href', liveLink);
          document.getElementById('liveViewPermission').textContent = 'Join Now';
          document.getElementById('liveViewPermission').classList.remove('disabled-btn');
          actionUrl = liveLink;
        } else {
          document.getElementById('liveStoryPopup').querySelector('.live-story-endsin').classList.add('hide');
          document.getElementById('liveStoryPopup').querySelector('.wallet').classList.remove('hide');
          document.getElementById('payLiveStoryBtn').textContent = 'Prebook ';
          actionUrl = "".concat(URL_BASE, "/send/prebook/live");
        }
      }
      document.querySelector('#liveStoryPopup .live-name').innerHTML = "\"".concat(livename, "\"");
      document.querySelector('#liveStoryPopup .user a').setAttribute('href', creatorURL);
      document.querySelector('#liveStoryPopup .user .avatar').setAttribute('src', avatarUrl);
      document.querySelector('#liveStoryPopup .user .name').innerHTML = name;
      document.querySelector('#liveStoryPopup .user .username').innerHTML = username;
      document.getElementById('dateTime').querySelector('span').textContent = localDateTime;
      document.getElementById('duration').querySelector('span').textContent = "".concat(duration, " minutes");
      if (availability == 'everyone_free' || isSubscribed && availability == 'free_paid_subscribers') {
        document.querySelector('.live-story-price span').textContent = "0";
      } else {
        document.querySelector('.live-story-price span').textContent = price;
      }
      if (isPrebooked || liveViewUser) {
        document.getElementById('liveStoryPopup').querySelector('.wallet').classList.add('hide');
        document.getElementById('liveStoryPopup').querySelector('.title').classList.add('hide');
        document.getElementById('liveStoryPopup').querySelector('p').classList.add('hide');
        document.getElementById('liveStoryPopup').querySelector('.alertMsg-1').classList.add('join-msg-1');
        document.getElementById('payLiveStoryBtn').classList.add('hide');
        document.getElementById('liveViewPermission').classList.remove('hide');
        document.getElementById('liveViewPermission').setAttribute('href', liveLink);
        document.getElementById('liveViewPermission').textContent = "Join Now";
        if (isPrebooked) {
          if (isPrebooked === '1') {
            document.querySelector('#liveStoryPopup .alertMsg-1').textContent = "Hi, You have already Prebooked for this Live Event !! You can Join Live at the sheduled Time!!";
          } else {
            document.querySelector('#liveStoryPopup .alertMsg-1').textContent = "Hi, You have successfully Prebooked for this Live Event !! You can Join Live at the sheduled Time!!";
            item.setAttribute('data-prebook', '1');
          }
        }
        if (liveViewUser) {
          var popupPrebookCount = document.getElementById('prebookCount');
          popupPrebookCount.querySelector('span').textContent = "".concat(prebookCount);
          popupPrebookCount.classList.remove('hide');
        }
      } else {
        document.getElementById('payLiveStoryBtn').textContent = 'Prebook';
        document.getElementById('payLiveStoryBtn').classList.remove('disabled');
        document.getElementById('formPayLiveStory').action = actionUrl;
        document.getElementById('formPayLiveStory').querySelector('input[name="id"]').value = liveId;
        document.getElementById('formPayLiveStory').querySelector('input[name="user_id"]').value = liveId;
        document.getElementById('formPayLiveStory').querySelector('input[name="live_id"]').value = liveChannel;
        document.getElementById('formPayLiveStory').querySelector('input[name="amount"]').value = price;
      }
      window.openModal('liveStoryPopup', e);
    });
  });
  var updateWalletAmount = function updateWalletAmount(walletAmount) {
    var walletAmountElements = document.querySelectorAll('.amountUpdate');
    walletAmountElements.forEach(function (element) {
      element.textContent = walletAmount;
    });
  };
  var viewMoreLink = document.getElementById('toggleNote');
  var moreContent = document.getElementById('viewMoreNote');

  // Toggle content visibility
  if (viewMoreLink) {
    viewMoreLink.addEventListener('click', function (event) {
      event.preventDefault();
      if (moreContent.style.display === 'none') {
        moreContent.style.display = 'inline';
        viewMoreLink.textContent = 'View Less';
      } else {
        moreContent.style.display = 'none';
        viewMoreLink.textContent = 'View More';
      }
    });
  }
  function clearModalData() {
    document.querySelector('#liveStoryPopup .live-name').innerHTML = '';
    document.querySelector('#liveStoryPopup .user a').setAttribute('href', '');
    document.querySelector('#liveStoryPopup .user .avatar').setAttribute('src', '');
    document.querySelector('#liveStoryPopup .user .name').innerHTML = '';
    document.querySelector('#liveStoryPopup .user .username').innerHTML = '';
    document.getElementById('dateTime').querySelector('span').textContent = '';
    document.getElementById('duration').querySelector('span').textContent = '';
    document.querySelector('.live-story-price span').textContent = '';
    document.getElementById('prebookCount').querySelector('span').textContent = '';
    document.querySelector('#liveStoryPopup .alertMsg-1').textContent = '';
    document.querySelector('#liveStoryPopup .wallet').classList.remove('hide');
    document.querySelector('#liveStoryPopup .alertMsg-1').classList.remove('join-msg-1');
    document.querySelector('#liveStoryPopup p').classList.remove('hide');
    document.querySelector('#liveStoryPopup .title').classList.remove('hide');
    document.querySelector('#liveStoryPopup .live-story-price').classList.remove('hide');
    document.getElementById('payLiveStoryBtn').classList.add('disabled');
    document.getElementById('payLiveStoryBtn').classList.remove('hide');
    document.getElementById('liveViewPermission').classList.add('hide');
    document.getElementById('liveViewPermission').classList.add('disabled');
    document.getElementById('liveViewPermission').classList.remove('blk-btn');
    document.getElementById('liveViewPermission').classList.add('disabled-btn');
    // Reset the toggle content visibility
    moreContent.style.display = 'none';
    viewMoreLink.textContent = 'View More';
  }
};
module.exports = liveStoryForm;

},{}],6:[function(require,module,exports){
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var modalPrebook = function modalPrebook() {
  var handlePrebookForm = function handlePrebookForm(e) {
    e.preventDefault();
    var form = e.target;
    var button = e.target.closest('.blk-btn');
    button.classList.add('disabled');
    button.querySelector('i').classList.add('spinner');
    if (e.target.classList.contains('blk-btn')) {
      var body = e.target.closest('.body');
      form = body.querySelector('form');
    }
    var data = {};
    var formData = new FormData(form);
    var parentEl = document.querySelector('#prebookModal');
    var _iterator = _createForOfIteratorHelper(formData.entries()),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
          key = _step$value[0],
          value = _step$value[1];
        data[key] = value;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    fetch(form.action, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(data)
    }).then(function (response) {
      return response.json();
    }).then(function (result) {
      if (result.errors) {
        window.showFormError(result.errors, parentEl);
        button.classList.remove('disabled');
        button.querySelector('i').classList.remove('spinner');
      }
      if (result.success) {
        if (result.url) {
          window.location.href = result.url;
        } else {
          var name = parentEl.querySelector('.name').innerHTML.trim();
          var username = parentEl.querySelector('.username span').innerHTML.trim();
          var coins = parentEl.querySelector('.live-coins').innerHTML.trim();
          document.querySelector('#jsModal .header').innerHTML = name;
          document.querySelector('#jsModal .body').innerHTML = "<div class=\"tipFormSuccess\"><div class=\"username global\">@".concat(username, " <img src=\"").concat(STATIC_URL, "/icons/verified.svg\" width=\"10\" height=\"10\"></div><div class=\"txt-indicator\">Thank you</div><div class=\"tip-txt\">You have successfully Prebooked ").concat(coins, " coins.</div>");
          walletAmount = result.wallet;
          button.classList.remove('disabled');
          button.querySelector('i').classList.remove('spinner');
          window.closeModal('prebookModal');
          window.openModal('jsModal', e);
          form.reset();
          var prebookBtn = document.querySelector('.prebook');
          prebookBtn.setAttribute('src', "".concat(URL_BASE, "/live/").concat(username));
          prebookBtn.innerHTML = 'Join Now';
          prebookBtn.classList.remove('prebook');
          prebookBtn.classList.add('disabled');
          prebookBtn.classList.add('disabled-btn');
        }
      }
    });
  };
};
module.exports = modalPrebook;

},{}],7:[function(require,module,exports){
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var modalTip = function modalTip() {
  var handleTipForm = function handleTipForm(e) {
    e.preventDefault();
    var form = e.target;
    var tipModal = document.getElementById('tipModal');
    if (tipModal) {
      var errorcontainer = tipModal.querySelector('.formError');
      errorcontainer.style.display = 'none';
      errorcontainer.querySelector('.showFormErrors').innerHTML = '';
      var tipModalBtn = document.getElementById('tipModalBtn');
      if (tipModalBtn.classList.contains('disabled')) {
        return;
      }
      tipModalBtn.classList.add('disabled');
      tipModalBtn.querySelector('i').classList.add('spinner');
      if (e.target.classList.contains('blk-btn')) {
        var body = e.target.closest('.body');
        form = body.querySelector('form');
      }
      var data = {};
      var formData = new FormData(form);
      var _iterator = _createForOfIteratorHelper(formData.entries()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
            key = _step$value[0],
            value = _step$value[1];
          data[key] = value;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      fetch(form.action, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(data)
      }).then(function (response) {
        return response.json();
      }).then(function (result) {
        tipModalBtn.classList.remove('disabled');
        tipModalBtn.querySelector('i').classList.remove('spinner');
        if (result.errors) {
          var parentEl = document.querySelector('#tipModal');
          window.showFormError(result.errors, parentEl);
        }
        if (result.success) {
          updateWalletAmount(result.wallet);
          clearcoinCoversion();
          if (result.url) {
            window.location = result.url;
          } else {
            if (result.messageId) {
              var msgToUserId = tipModal.querySelector('#tipModal #id').value;
              if (msgToUserId) {
                socket.emit('chat-send', {
                  toUserId: msgToUserId,
                  messageId: result.messageId
                });
              }
            }
            document.querySelector('#jsModal .header').innerHTML = result.name;
            if (result.msgUrl) {
              document.querySelector('#jsModal .body').innerHTML = "<div class=\"tipFormSuccess\">\n                <div class=\"username global\">".concat(result.username, " \n                  <img src=\"").concat(STATIC_URL, "/icons/verified.svg\" width=\"10\" height=\"10\">\n                </div>\n                <div class=\"txt-indicator\">Thank you! You have successfully tipped ").concat(result.coins, " coins!</div>\n                <div class=\"tip-txt\">\n                  <span class=\"d-block tip-txt\">You can now say Hi to ").concat(result.name, "!</span>\n                  <a class=\"sml-btn pri-btn mr-5 mt-10\" href=\"").concat(result.msgUrl, "\">\n                    <span>Text Now</span>\n                  </a>\n                </div>");
            } else {
              document.querySelector('#jsModal .body').innerHTML = "<div class=\"tipFormSuccess\"><div class=\"username global\">".concat(result.username, " <img src=\"").concat(STATIC_URL, "/icons/verified.svg\" width=\"10\" height=\"10\"></div><div class=\"txt-indicator\">Thank you</div><div class=\"tip-txt\">You have successfully tipped ").concat(result.coins, " coins.</div>");
            }
            walletAmount = result.wallet;
            window.closeModal('tipModal');
            window.openModal('jsModal', e);
            form.reset();
          }
        }
      });
    }
  };
  var updateWalletAmount = function updateWalletAmount(walletAmount) {
    var walletAmountElements = document.querySelectorAll('.amountUpdate');
    walletAmountElements.forEach(function (element) {
      element.textContent = walletAmount;
    });
  };
  var socket = window.socket;
  // Tip Modal
  var tipBtn = document.querySelector('.tip');
  if (tipBtn) {
    tipBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var tipModal = document.getElementById('tipModal');
      if (tipModal) {
        var errorcontainer = tipModal.querySelector('.formError');
        errorcontainer.style.display = 'none';
        errorcontainer.querySelector('.showFormErrors').innerHTML = '';
        var modal = document.querySelector('#tipModal');
        var url = modal.querySelector('.info').getAttribute('data-href') + '/' + tipBtn.getAttribute('data-username');
        modal.querySelector('.info').setAttribute('href', url);
        var profileImage = modal.querySelector('.info .tip-modal-prfl img');
        var imgSrc = profileImage.getAttribute('data-src');
        profileImage.setAttribute('src', imgSrc + tipBtn.getAttribute('data-avatar'));
        modal.querySelector('.cName').innerHTML = tipBtn.getAttribute('data-name');
        modal.querySelector('.userName').innerHTML = '@' + tipBtn.getAttribute('data-username');
        modal.querySelector('#tipModal #id').value = tipBtn.getAttribute('data-id');
        var currentURL = window.location.href;
        if (currentURL.includes('message')) {
          modal.querySelector('#tipModal #isMessage').value = 1;
        } else if (currentURL.includes('live')) {
          modal.querySelector('#tipModal #isLive').value = 1;
        }
        clearcoinCoversion();
        window.openModal('tipModal', e);
      }
    });
  }
  document.addEventListener('click', function (event) {
    if (event.target.matches('#tipModal .blk-btn')) {
      handleTipForm(event);
    }
  });
  document.addEventListener('submit', function (event) {
    if (event.target.matches('#tipModal form')) {
      handleTipForm(event);
    }
  });

  // coin conversion
  function coinCoversion(inputElement, displayElement) {
    var coins = parseFloat(inputElement.value);
    if (!isNaN(coins) && coins > 0) {
      var price = (priceOfOneCoin * coins).toFixed(2);
      displayElement.innerHTML = "".concat(coins, " is equivalent to ").concat(price, " ").concat(userCurrency);
    } else {
      displayElement.innerHTML = " ";
    }
  }
  function clearcoinCoversion() {
    var conversionDisplay = document.getElementById('coinCoversionTip');
    if (conversionDisplay) {
      conversionDisplay.innerHTML = " ";
    }
  }
  var priceInput = document.getElementById('onlyNumber');
  var conversionDisplay = document.getElementById('coinCoversionTip');
  if (priceInput) {
    priceInput.addEventListener('input', function () {
      coinCoversion(this, conversionDisplay);
    });
  }
};
module.exports = modalTip;

},{}],8:[function(require,module,exports){
"use strict";

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var productBuying = function productBuying() {
  var buyNow = document.querySelector('.buyNow');
  var purchaseButton = document.querySelector('.purchaseButton');
  var buyProduct = function buyProduct(e) {
    e.preventDefault();
    var productDiv = e.target.closest('.purchasing-shop-list');
    if (productDiv) {
      var id = productDiv.getAttribute('data-id');
      var name = productDiv.getAttribute('data-name');
      var type = productDiv.getAttribute('data-type');
      var desc = productDiv.querySelector('.descSpan');
      var price = productDiv.getAttribute('data-price');
      var date = productDiv.getAttribute('data-date');
      var userPurchased = productDiv.getAttribute('data-purchased');
      var hastags = productDiv.querySelector('.hashtags');
      var purchaseCount = productDiv.getAttribute('data-purchase-count');
      var timeDesc = productDiv.querySelector('.time-desc');
      var productImg = productDiv.querySelector('.prdct-img');
      var imgSrc = productImg.querySelector('img').getAttribute('src');
      window.openModal('modalProductsBuying');
      var modalBuy = document.querySelector('#modalProductsBuying');
      var timePopup = modalBuy.querySelector('.days-cnt');
      timePopup.innerHTML = timeDesc.innerHTML;
      var pBuyDesc = modalBuy.querySelector('.p-buy-desc');
      pBuyDesc.innerHTML = desc.innerHTML;
      var datePopup = modalBuy.querySelector('.date-list');
      datePopup.innerHTML = date;
      var header = modalBuy.querySelector('.header');
      header.innerHTML = name;
      var count = modalBuy.querySelector('.purchase-cnt');
      count.innerHTML = purchaseCount;
      var img = modalBuy.querySelector('.p-buy-img');
      var pBuyTags = modalBuy.querySelector('.p-buy-tags');
      pBuyTags.innerHTML = hastags.innerHTML;
      var priceBottom = modalBuy.querySelector('.price-buy-nw .price span');
      priceBottom.innerHTML = price;

      //If user is already purchased the digital product, then display the download button
      var downloadBtn = modalBuy.querySelector('.download-btn');
      if (downloadBtn && buyNow) {
        if (userPurchased > 0 && type == 'digital') {
          buyNow.classList.add('hide');
          downloadBtn.classList.remove('hide');
          downloadBtn.href = "".concat(URL_BASE, "/product/download/").concat(id);
        } else {
          buyNow.classList.remove('hide');
          downloadBtn.classList.add('hide');
        }
        downloadBtn.addEventListener('click', function (e) {
          window.closeModal('modalProductsBuying');
          document.querySelector('#jsModal .header').innerHTML = 'Success!!';
          document.querySelector('#jsModal .body').innerHTML = 'Downloaded successfully...';
          window.openModal('jsModal', e);
        });
      }
      img.setAttribute('src', imgSrc);
      if (buyNow) {
        buyNow.setAttribute('data-id', id);
        buyNow.setAttribute('data-name', name);
        buyNow.setAttribute('data-price', price);
        buyNow.setAttribute('data-type', type);
      }
    }
  };
  if (buyNow) {
    buyNow.addEventListener('click', function (e) {
      e.preventDefault();

      // Hide formError container and clear previous error messages 
      if (productForm) {
        var errorcontainer = productForm.querySelector('.formError');
        if (errorcontainer) {
          errorcontainer.style.display = 'none';
          errorcontainer.querySelector('.showFormErrors').innerHTML = '';
        }
      }
      var id = e.target.getAttribute('data-id');
      var productName = e.target.getAttribute('data-name');
      var price = e.target.getAttribute('data-price');
      var agree = document.querySelector('.agree');
      var type = e.target.getAttribute('data-type');
      if (type == 'digital') {
        agree.classList.add('hide');
      } else {
        agree.classList.remove('hide');
      }
      window.closeModal('modalProductsBuying');
      var modalProductsBuyingForm = document.querySelector('#modalProductsBuyingForm');
      if (modalProductsBuyingForm) {
        var name = modalProductsBuyingForm.querySelector('.header');
        var productId = modalProductsBuyingForm.querySelector('#id');
        productId.setAttribute('value', id);
        name.innerHTML = productName;
        purchaseButton.querySelector('span').innerHTML = price;
        var textArea = modalProductsBuyingForm.querySelector('.textArea');
        textArea.innerHTML = "";
        if (type == "digital") {
          textArea.classList.add('hide');
          modalProductsBuyingForm.querySelector('.viewMoreDiv').classList.add('hide');
          modalProductsBuyingForm.querySelector('.hint').classList.add('hide');
        } else {
          textArea.classList.remove('hide');
          modalProductsBuyingForm.querySelector('.viewMoreDiv').classList.remove('hide');
          modalProductsBuyingForm.querySelector('.hint').classList.remove('hide');
        }
      }
      window.openModal('modalProductsBuyingForm');
    });
  }
  var productForm = document.querySelector('#productForm');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(productForm);
      fetch(this.action, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      }).then(function (response) {
        if (!response.ok) {
          throw new Error('Network response was not ok.');
        }
        return response.json();
      }).then(function (result) {
        if (result.success) {
          updateWalletAmount(result.wallet);
          //User purchase the digital product
          if (result.url && result.url.indexOf('product/download') !== -1) {
            document.querySelector('#jsModal .header').innerHTML = 'Success!!';
            document.querySelector('#jsModal .body').innerHTML = 'Purchased successfully...';
            window.closeModal('modalProductsBuyingForm');
            window.openModal('jsModal', e);
            window.location.reload();
          }
          //If user have not enough funds, redirect to the wallet page
          else if (result.url && result.url.indexOf('my/wallet') !== -1) {
            window.location.href = result.url;
          }
          //User purchase the custom content
          else if (result.buyCustomContent) {
            document.querySelector('#jsModal .header').innerHTML = 'Success!!';
            document.querySelector('#jsModal .body').innerHTML = 'Purchased successfully...';
            window.closeModal('modalProductsBuyingForm');
            window.openModal('jsModal', e);
          }
        } else if (result.errors) {
          // If the result contains errors,then display the error message
          window.showFormError(result.errors, productForm);
        }
      })["catch"](function (error) {
        throw new Error('Failed to process restrict action: ' + error.message);
      });
    });
  }
  var updateWalletAmount = function updateWalletAmount(walletAmount) {
    var walletAmountElements = document.querySelectorAll('.amountUpdate');
    walletAmountElements.forEach(function (element) {
      element.textContent = walletAmount;
    });
  };
  var productBuy = document.querySelectorAll('.prduct-buy');
  if (productBuy) {
    productBuy.forEach(function (product) {
      product.addEventListener('click', buyProduct);
    });
  }
  var observeMutations = function observeMutations(targetNode) {
    var config = {
      childList: true,
      subtree: true
    };
    var callback = function callback(mutationsList) {
      var _iterator = _createForOfIteratorHelper(mutationsList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var mutation = _step.value;
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach(function (node) {
              if (node.nodeType === 1) {
                var productObserver = node.querySelector('.prduct-buy') || node.classList.contains('prduct-buy') && node;
                if (productObserver) {
                  productObserver.addEventListener('click', buyProduct);
                }
              }
            });
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    };
    var observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  };
  observeMutations(document.body);
};
module.exports = productBuying;

},{}],9:[function(require,module,exports){
"use strict";

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var profile = function profile() {
  // // Tabs Switch Logic
  // const tabs = document.querySelectorAll('.prf-tab-wrap .tab');
  // if (tabs) {
  //   tabs.forEach(element => {
  //     element.addEventListener('click', (e) => {
  //       const target = e.target.getAttribute('data-target')
  //       document.querySelectorAll('.tab-item').forEach(ele => {
  //         ele.style.display = 'none';
  //       });
  //       document.querySelector(`.${target}-wrap`).style.display = 'block';
  //       tabs.forEach(ele => {
  //         ele.classList.remove('blk')
  //       })
  //       document.querySelector(`#${target}-tab`).classList.add('blk');
  //     })
  //   });

  // Share link
  var shareLink = document.querySelector('.prf-share');
  if (shareLink) {
    shareLink.addEventListener('click', function (e) {
      e.preventDefault();
      var unfollowBtn = document.querySelector('.unfollow-icon');
      if (unfollowBtn) {
        var creatorId = unfollowBtn.getAttribute('data-user');
        if (Array.isArray(fc) && fc.includes(parseInt(creatorId))) {
          unfollowBtn.classList.remove('hide');
        } else {
          unfollowBtn.classList.add('hide');
        }
      }
      window.openModal('profileShareModal', e, true);
    });
  }
  var shareIcon = document.querySelector('.share-icon');
  if (shareIcon) {
    shareIcon.addEventListener('click', function (e) {
      e.preventDefault();
      window.closeModal('profileShareModal');
      window.openModal('profileShareSocialModal', e, true);
      var linkShare = document.querySelector('.link-share');
      if (linkShare) {
        linkShare.addEventListener('click', function (e) {
          var copy_link = document.querySelector('#copy_link');
          if (copy_link) {
            window.copyToClipboard(copy_link.value);
          }
          window.closeModal('profileShareSocialModal');
        });
      }
    });
  }
  var restrictUser = document.querySelector('#userRestriction');
  if (restrictUser) {
    restrictUser.addEventListener('click', function (e) {
      e.preventDefault();
      window.closeModal('profileShareModal');
      var element = e.target;
      var id = element.getAttribute("data-user");
      var restrictUserModalText = document.getElementById('modalText');
      var restrictText = document.querySelector('.restrict-text');
      var restrictBtn = document.querySelector('.restrict-btn');
      var confirmBtn = document.querySelector('.confirm-btn');
      if (element.classList.contains('restrict-user')) {
        restrictUserModalText.textContent = 'Are you sure you want to restrict this user ?';
        window.openModal('restrictUserModal');
      } else if (element.classList.contains('remove-restrictUser')) {
        restrictUserModalText.textContent = 'Are you sure you want to remove restrictions for this user ?';
        window.openModal('restrictUserModal');
        confirmBtn.classList.remove('hide');
        restrictBtn.classList.add('hide');
        restrictText.classList.add('hide');
      }
      var submitBtn = confirmBtn.classList.contains('hide') ? restrictBtn : confirmBtn;
      if (submitBtn) {
        submitBtn.addEventListener('click', function (e) {
          e.preventDefault();
          submitBtn.classList.add('disabled');
          submitBtn.querySelector('i').classList.add('spinner');
          // Fetch request here
          fetch("".concat(URL_BASE, "/restrict/user/").concat(id), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            },
            body: JSON.stringify({})
          }).then(function (response) {
            if (!response.ok) {
              throw new Error('Network response was not ok.');
            }
            return response.json();
          }).then(function (result) {
            if (result.success) {
              document.querySelector('#jsModal .header').innerHTML = 'Success!!';
              document.querySelector('#jsModal .body').innerHTML = 'You are restricting this user!';
            } else if (result.errors) {
              document.querySelector('#jsModal .header').innerHTML = 'Oops!!';
              document.querySelector('#jsModal .body').innerHTML = 'Something went wrong';
            }
            window.closeModal('restrictUserModal');
            confirmBtn.classList.remove('hide');
            restrictBtn.classList.add('hide');
            window.openModal('jsModal', e);
            window.location.reload();
          })["catch"](function (error) {
            throw new Error('Failed to process restrict action: ' + error.message);
          });
        });
      }
    });
  }

  //change the image when page is active
  var activeMediaTypes = document.querySelectorAll('.media-type');
  if (activeMediaTypes) {
    activeMediaTypes.forEach(function (e) {
      var img = e.querySelector('img');
      if (img) {
        if (e.classList.contains('active')) {
          replaceSrc(img, true);
        } else {
          replaceSrc(img, false);
        }
      }
    });
  }

  //get the sort value and submit
  var sortDropdown = document.getElementById('sort-dropdown');
  if (sortDropdown) {
    sortDropdown.addEventListener('change', function () {
      var sortForm = document.getElementById('sort-form');
      var selectedValue = this.value;
      var baseUrl = sortForm.getAttribute('action');
      if (selectedValue !== '') {
        sortForm.action = baseUrl + '?sort=' + selectedValue;
      } else {
        sortForm.action = baseUrl;
      }
      sortForm.submit();
    });
  }

  // add event listener for paid subscription & free subscription 
  var handleSubscribeButton = function handleSubscribeButton(e) {
    e.preventDefault();
    var subscriptionForm = document.getElementById('formSubscription');
    var errorcontainer = subscriptionForm.querySelector('.formError');
    errorcontainer.style.display = 'none';
    errorcontainer.querySelector('.showFormErrors').innerHTML = '';
    subscriptionForm.reset();
    window.openModal('subscribeModal', e);
    var radios = document.querySelectorAll('.radio');
    var updateBorders = function updateBorders() {
      var subscriptionPrice = document.querySelectorAll('.subscription-price');
      subscriptionPrice.forEach(function (border) {
        border.classList.remove('border-blk');
      });
      radios.forEach(function (radio) {
        if (radio.checked) {
          radio.closest('.subscription-price').classList.add('border-blk');
        }
      });
    };
    radios.forEach(function (radio) {
      radio.addEventListener('change', updateBorders);
    });
    updateBorders();
  };
  var subscribeButton = document.querySelector('.subscribe-btn,.subscribe-btn img, .subscribe-btn span');
  if (subscribeButton) {
    subscribeButton.addEventListener('click', handleSubscribeButton);
  }
  //add event listener for cancel subscription
  document.addEventListener('click', function (e) {
    if (e.target.matches('.unsubscribe-btn')) {
      e.preventDefault();
      window.openModal('cancelSubscription', e);
    }
  });

  //moreInfo
  var viewMoreFunction = function viewMoreFunction(event) {
    var para = event.target.closest('.viewMoreDiv');
    var moreContent = para.querySelector('.viewMoreStory');
    event.preventDefault();
    if (moreContent.style.display === 'none') {
      moreContent.style.display = 'inline';
      event.target.textContent = 'Less info';
    } else {
      moreContent.style.display = 'none';
      event.target.textContent = 'More info';
    }
  };
  var viewMoreLink = document.querySelectorAll('.toggleStory');
  if (viewMoreLink) {
    viewMoreLink.forEach(function (view) {
      view.addEventListener('click', viewMoreFunction);
    });
  }

  // Live Streaming Date Conversion
  var liveDateTimeEle = document.querySelector('.jsliveDate');
  if (liveDateTimeEle && liveDateTimeEle.innerHTML) {
    var _liveDateTimeEle$inne = liveDateTimeEle.innerHTML.split(' '),
      _liveDateTimeEle$inne2 = _slicedToArray(_liveDateTimeEle$inne, 1),
      scheduleDate = _liveDateTimeEle$inne2[0];
    if (scheduleDate) {
      var _scheduleDate$split = scheduleDate.split('-'),
        _scheduleDate$split2 = _slicedToArray(_scheduleDate$split, 3),
        schYear = _scheduleDate$split2[0],
        schMonth = _scheduleDate$split2[1],
        schDay = _scheduleDate$split2[2];
      var d = new Date(schYear, schMonth - 1, schDay);

      // Format the local date
      var localDateString = d.toLocaleDateString("en-IN", {
        day: "numeric",
        month: "short",
        year: "numeric"
      });
      var formattedDate = localDateString.replace(/(\d{1,2}\s\w+)(\s)(\d{4})/, '$1, $3');
      liveDateTimeEle.innerHTML = formattedDate;
    }
  }

  //delete the scheduled live
  var liveDeleteBtn = document.querySelector('.actionDeleteSchedule');
  if (liveDeleteBtn) {
    liveDeleteBtn.addEventListener('click', function (e) {
      e.preventDefault();
      window.openModal('deleteSchLive');
      var isConfirm = document.getElementById('confirmDelete');
      if (isConfirm) {
        isConfirm.addEventListener('click', function (e) {
          e.preventDefault();
          isConfirm.querySelector('i').classList.add('spinner');
          var liveDeleteForm = document.getElementById('deleteForm');
          fetch(liveDeleteForm.action, {
            method: 'GET',
            headers: {
              'Accept': 'application/json'
            }
          }).then(function (response) {
            return response.json();
          }).then(function (data) {
            isConfirm.querySelector('i').classList.remove('spinner');
            if (data.success) {
              window.location.href = data.url;
            } else {
              console.log('Error:', data.error);
            }
          })["catch"](function (error) {
            isConfirm.querySelector('i').classList.remove('spinner');
            console.log('Error:', error);
          });
        });
      }
    });
  }
  var closeToolTip = document.querySelector('.close-tooltip');
  if (closeToolTip) {
    closeToolTip.addEventListener('click', function (e) {
      e.preventDefault();
      var tooltip = document.querySelector('.tooltip-show');
      if (tooltip) {
        tooltip.style.visibility = 'hidden';
      }
    });
  }
  var logInSignUpHandler = function logInSignUpHandler() {
    var signUpElement = document.querySelectorAll('.logIn-signUp');
    if (signUpElement.length > 0) {
      signUpElement.forEach(function (signUp) {
        signUp.addEventListener('click', function (e) {
          e.preventDefault();
          var mob = document.querySelector('.mob-ham.show');
          if (mob) {
            mob.classList.remove('show');
            mob.classList.add('hide-tgl');
            mob.addEventListener('animationend', function () {
              mob.style.display = 'none';
            }, {
              once: true
            });
          }
          window.openModal('logIn-signUp', e, true);
        });
      });
    }
  };
  var observeMutations = function observeMutations(targetNode) {
    var config = {
      childList: true,
      subtree: true
    };
    var callback = function callback(mutationsList) {
      var _iterator = _createForOfIteratorHelper(mutationsList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var mutation = _step.value;
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach(function (node) {
              if (node.nodeType === 1) {
                var logInSignUp = node.querySelector('.logIn-signUp');
                if (logInSignUp) {
                  logInSignUpHandler();
                }
              }
            });
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    };
    var observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  };
  logInSignUpHandler();
  observeMutations(document.body);
  var resetFormFields = function resetFormFields(formSelector) {
    var form = document.querySelector(formSelector);
    if (form) {
      form.reset();
      var errorContainer = form.querySelector('.formError');
      if (errorContainer) {
        errorContainer.style.display = 'none';
        var errorList = errorContainer.querySelector('.showFormErrors');
        if (errorList) errorList.innerHTML = '';
      }
    }
  };
  var tabs = document.querySelectorAll('.tab');
  var tabContents = document.querySelectorAll('.tab-items');
  var TabClickHandler = function TabClickHandler(e) {
    e.preventDefault();
    var target = e.currentTarget.getAttribute('data-target');

    // Hide all tab contents
    tabContents.forEach(function (content) {
      content.classList.add('hide');
    });

    // Show the selected tab content
    var selectedTabContent = document.querySelector(".".concat(target, "-wrap"));
    if (selectedTabContent) {
      selectedTabContent.classList.remove('hide');
    }
    if (target === 'logIn') {
      resetFormFields('#formSignupRegister');
    } else if (target === 'signUp') {
      resetFormFields('#formLoginRegister');
    }
    // Toggle classes for active tab
    tabs.forEach(function (tab) {
      tab.classList.toggle('l', tab.getAttribute('data-target') === target);
      tab.classList.toggle('blk', tab.getAttribute('data-target') !== target);
    });
    localStorage.setItem('activeTab', target);
  };
  if (tabs) {
    tabs.forEach(function (tab) {
      tab.addEventListener('click', TabClickHandler);
    });
  }
  document.addEventListener('click', function (e) {
    if (e.target.id === 'btnLoginRegister' || e.target.id === 'btnSignupRegister') {
      e.preventDefault();

      // Determine which form to process based on the button clicked
      var formId = e.target.id === 'btnLoginRegister' ? 'formLoginRegister' : 'formSignupRegister';
      var buttonId = e.target.id === 'btnLoginRegister' ? 'btnLoginRegister' : 'btnSignupRegister';
      sendFormLoginRegister(formId, buttonId);

      // Remove displayed error messages for both forms
      var loginForm = document.getElementById('formLoginRegister');
      var signupForm = document.getElementById('formSignupRegister');
      var verify2FaForm = document.getElementById('formVerify2fa');
      [loginForm, signupForm, verify2FaForm].forEach(function (form) {
        if (form) {
          var errorContainer = form.querySelector('.formError');
          if (errorContainer) {
            errorContainer.style.display = 'none';
            var errorList = errorContainer.querySelector('.showFormErrors');
            if (errorList) errorList.innerHTML = '';
          }
        }
      });
    }
  });

  //login and register form submission
  var sendFormLoginRegister = function sendFormLoginRegister(formId, buttonId) {
    var btnLoginRegister = document.getElementById(buttonId);
    var loginRegisterForm = document.getElementById(formId);
    btnLoginRegister.classList.add('disabled');
    btnLoginRegister.querySelector('i').classList.add('spinner');
    var formData = new FormData(loginRegisterForm);
    var loginSignupData = {};
    // Get CSRF token from meta tag
    var csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    var formElements = loginRegisterForm.querySelectorAll('form input, form select, form textarea');
    formElements.forEach(function (element) {
      if (element.name) {
        loginSignupData[element.name] = element.value;
      }
    });
    fetch(loginRegisterForm.action, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-CSRF-TOKEN': csrfToken
      },
      body: JSON.stringify(loginSignupData)
    }).then(function (response) {
      if (response.status == 419) {
        window.closeModal('logIn-signUp');
        btnLoginRegister.classList.remove('disabled');
        btnLoginRegister.querySelector('i').classList.remove('spinner');
        document.querySelector('#jsModal .header').innerHTML = 'Session Expired';
        document.querySelector('#jsModal .body').innerHTML = '<br>Your session has expired. Please refresh the page to continue..';
        // Create a new button for refresh
        var refreshBtn = document.createElement('a');
        refreshBtn.setAttribute('href', 'javascript:void(0);');
        refreshBtn.innerHTML = 'Refresh';
        refreshBtn.classList.add('refresh', 'sml-btn', 'blk-btn');
        refreshBtn.addEventListener('click', function () {
          location.reload();
        });
        document.querySelector('#jsModal .body').appendChild(refreshBtn);
        window.openModal('jsModal', event);
      }
      return response.json();
    }).then(function (result) {
      if (result.actionRequired) {
        window.openModal('jsModal', event);
        return false;
      }
      if (result.success) {
        //redirected to the url return page when result is success
        if (result.isModal) {
          window.location.reload();
        } else if (result.url_return) {
          window.location.href = result.url_return;
        }
      } else {
        if (result.errors) {
          var erMsg = result.errors;
          window.showFormError(erMsg, loginRegisterForm);
          btnLoginRegister.classList.remove('disabled');
          btnLoginRegister.querySelector('i').classList.remove('spinner');
        }
      }
    })["catch"](function (error) {
      btnLoginRegister.classList.remove('disabled');
      btnLoginRegister.querySelector('i').classList.remove('spinner');
      var erMsg = {
        error: error_occurred
      };
      window.showFormError(erMsg, loginRegisterForm);
      console.error(error);
    });
  };
  var loginPasswordInput = document.querySelector('#showHidePassword input');
  var signupPasswordInput = document.querySelector('#showHidePasswords input');
  var loginEyeIcons = document.querySelectorAll('#showHidePassword .togglePwd');
  var signupEyeIcons = document.querySelectorAll('#showHidePasswords .togglePwds');

  // Common function to toggle password visibility
  var hideAndShowPassword = function hideAndShowPassword(input, icons) {
    icons.forEach(function (icon) {
      return icon.classList.toggle('hide');
    });
    input.type = input.type === 'password' ? 'text' : 'password';
  };
  if (loginPasswordInput && loginEyeIcons) {
    loginEyeIcons.forEach(function (icon) {
      icon.addEventListener('click', function () {
        return hideAndShowPassword(loginPasswordInput, loginEyeIcons);
      });
    });
  }
  if (signupPasswordInput && signupEyeIcons) {
    signupEyeIcons.forEach(function (icon) {
      icon.addEventListener('click', function () {
        return hideAndShowPassword(signupPasswordInput, signupEyeIcons);
      });
    });
  }
  // Add event listener for press 'ENTER' to submit Login/Register form & (2FAC)
  document.addEventListener('keydown', function (event) {
    if (event.key === "Enter") {
      if (document.activeElement.id === 'onlyNumber') {
        event.preventDefault();
        document.getElementById('btn2fa').click();
      }
      if (document.activeElement.id === 'loginUserName' || document.activeElement.id === 'loginRegisterPwd') {
        event.preventDefault();
        document.getElementById('btnLoginRegister').click();
      }
      if (document.activeElement.id === 'signupRegisterPwd') {
        event.preventDefault();
        document.getElementById('btnSignupRegister').click();
      }
    }
  });
  var checkbox = document.getElementById('customCheckRegister');
  checkbox.addEventListener('change', function () {
    if (this.checked) {
      this.value = 'on';
    } else {
      this.value = '';
    }
  });
  document.addEventListener('click', function (e) {
    if (e.target.id === 'switchToLogin') {
      e.preventDefault();
      var loginTab = document.querySelector('.logIn-wrap');
      var signupTab = document.querySelector('.signUp-wrap');
      if (loginTab && signupTab) {
        loginTab.classList.remove('hide');
        signupTab.classList.add('hide');
      }
      var loginTabHeader = document.getElementById('logIn-tab');
      var signupTabHeader = document.getElementById('signUp-tab');
      if (loginTabHeader && signupTabHeader) {
        loginTabHeader.classList.add('l');
        loginTabHeader.classList.remove('blk');
        signupTabHeader.classList.add('blk');
        signupTabHeader.classList.remove('l');
      }
    }
  });
};
module.exports = profile;

},{}],10:[function(require,module,exports){
"use strict";

var refresh = function refresh() {
  var refreshListLinks = document.querySelectorAll('.refresh-list');
  if (refreshListLinks) {
    refreshListLinks.forEach(function (refreshListLink) {
      refreshListLink.addEventListener('click', function (event) {
        event.preventDefault();
        var scrollDivs = document.querySelectorAll('.scroll');
        scrollDivs.forEach(function (scrollDiv) {
          var skipIds = JSON.parse(scrollDiv.getAttribute('data-skip-ids'));
          var currentIndex = parseInt(scrollDiv.getAttribute('data-current-index'), 10);
          var data = {
            skip_ids: skipIds,
            take: 4,
            current_index: currentIndex,
            profile_id: profile_id
          };
          var fntn = "suggestedList";
          if (refreshListLink.classList.contains('nw-to-bngeme')) {
            fntn = "newToBingeme";
          }
          fetch("".concat(URL_BASE, "/refresh/").concat(fntn), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            },
            body: JSON.stringify(data)
          }).then(function (response) {
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
            return response.json();
          }).then(function (data) {
            console.log('Response data:', data);
            if (data.success) {
              scrollDiv.setAttribute('data-skip-ids', JSON.stringify(data.new_skip_ids));
              scrollDiv.setAttribute('data-current-index', data.new_current_index);
              // Clear current list
              scrollDiv.innerHTML = '';

              // Add new suggested creators HTML
              scrollDiv.innerHTML = data.html;

              // Check if the new list is empty and loop back to the beginning
              if (data.new_skip_ids.length === 0) {
                // Reset skipIds and currentIndex to initial values
                var initialSkipIds = JSON.parse(scrollDiv.getAttribute('data-initial-skip-ids'));
                scrollDiv.setAttribute('data-skip-ids', JSON.stringify(initialSkipIds));
                scrollDiv.setAttribute('data-current-index', '0');
              }
            } else {
              console.error('Failed to fetch new suggested creators or data format is incorrect');
            }
          })["catch"](function (error) {
            return console.error('Error:', error);
          });
        });
      });
    });
  }
};
module.exports = refresh;

},{}],11:[function(require,module,exports){
"use strict";

var reportUsers = function reportUsers() {
  //report the user
  var reportUser = document.querySelector('.report-user');
  var form = document.getElementById('reportUser-form');
  var reportNext = document.getElementById('reportUser-next');
  var reportUpdate = document.getElementById('reportUser-update');
  var textArea = document.getElementById('reportUser-message');
  var nextButton = document.querySelector('.nextbtn');
  var backButton = document.querySelector('.backbtn');
  var submitButton = document.querySelector('.submitbtn');
  if (reportUser) {
    reportUser.addEventListener('click', function (e) {
      e.preventDefault();
      window.closeModal('userReportModal');
      window.closeModal('profileShareModal');
      window.closeModal('notificationListModal');
      window.closeModal('messageListModal');
      if (backButton || submitButton) {
        backButton.classList.add('hide');
        submitButton.classList.add('hide');
        nextButton.classList.remove('hide');
      }
      reportNext.classList.remove('hide');
      reportUpdate.classList.add('hide');
      if (form) {
        var errorcontainer = form.querySelector('.formError');
        errorcontainer.style.display = 'none';
        errorcontainer.querySelector('.showFormErrors').innerHTML = '';
      }
      window.openModal('reportUserModal', e, true);
    });
  }
  if (nextButton) {
    nextButton.addEventListener('click', function (e) {
      e.preventDefault();
      if (textArea.value.length > 29) {
        reportNext.classList.add('hide');
        reportUpdate.classList.remove('hide');
        nextButton.classList.add('hide');
        backButton.classList.remove('hide');
        submitButton.classList.remove('hide');
        if (form) {
          var errorcontainer = form.querySelector('.formError');
          errorcontainer.style.display = 'none';
          errorcontainer.querySelector('.showFormErrors').innerHTML = '';
        }
      } else {
        var erMsg = {
          'error': "* Enter minimum 30 characters!"
        };
        window.showFormError(erMsg, form);
      }
    });
  }
  if (backButton) {
    backButton.addEventListener('click', function (e) {
      e.preventDefault();
      reportNext.classList.remove('hide');
      reportUpdate.classList.add('hide');
      nextButton.classList.remove('hide');
      backButton.classList.add('hide');
      submitButton.classList.add('hide');
      if (form) {
        var errorcontainer = form.querySelector('.formError');
        errorcontainer.style.display = 'none';
        errorcontainer.querySelector('.showFormErrors').innerHTML = '';
      }
    });
  }
  if (submitButton) {
    submitButton.addEventListener('click', function (e) {
      e.preventDefault();
      var form = e.target.closest('form');
      if (form) {
        var name = form.querySelector('.name').value;
        var email = form.querySelector('.email').value;
        var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        var nameRegex = /^[a-zA-Z0-9\s.]+$/;
        var isEmail = emailRegex.test(email);
        var isNameValid = nameRegex.test(name);
        var errorcontainer = form.querySelector('.formError');
        errorcontainer.style.display = 'none';
        errorcontainer.querySelector('.showFormErrors').innerHTML = '';
        var messages = [];
        // Accumulate error messages
        if (!isNameValid) {
          messages.push("* Name must contain only letters!");
        }
        name === "" && messages.push("* Name must be filled out!");
        (email === "" || !isEmail) && messages.push("* Enter valid Email");
        if (messages.length > 0) {
          window.showFormError(messages, form);
          return; // Prevent form submission
        }
        fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          headers: {
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            'Accept': 'application/json'
          }
        }).then(function (response) {
          return response.json();
        }).then(function (response) {
          if (response.success) {
            document.querySelector('#jsModal .header').innerHTML = 'Thanks!!';
            document.querySelector('#jsModal .body').innerHTML = 'Your report has been received and will be reviewed. Thanks for making Bingeme a safer place!';
          } else if (response.errors) {
            document.querySelector('#jsModal .header').innerHTML = 'Oops!!';
            document.querySelector('#jsModal .body').innerHTML = 'Already sent a report';
          }
          window.closeModal('reportUserModal');
          reportNext.classList.remove('hide');
          reportUpdate.classList.add('hide');
          nextButton.classList.remove('hide');
          backButton.classList.add('hide');
          submitButton.classList.add('hide');
          window.openModal('jsModal', e);
          form.reset();
        })["catch"](function (error) {
          throw new Error('Failed to process report action: ' + error.message);
        });
      }
    });
  }
};
module.exports = reportUsers;

},{}],12:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var subscription = function subscription() {
  // Paid subscription
  document.addEventListener('click', function (event) {
    if (event.target.matches('.subscriptionBtn')) {
      event.preventDefault();
      var subscriptionBtn = document.querySelector('.subscriptionBtn');
      var subscriptionForm = document.getElementById('formSubscription');
      if (subscriptionForm) {
        var errorcontainer = subscriptionForm.querySelector('.formError');
        errorcontainer.style.display = 'none';
        errorcontainer.querySelector('.showFormErrors').innerHTML = '';
      }
      subscriptionBtn.classList.add('disabled');
      subscriptionBtn.querySelector('i').classList.add('spinner');
      var formData = new FormData(subscriptionForm);
      var subscriptionData = {};
      var _iterator = _createForOfIteratorHelper(formData.entries()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
            key = _step$value[0],
            value = _step$value[1];
          subscriptionData[key] = value;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var response, result, erMsg, _erMsg;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return fetch(subscriptionForm.action, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json'
                },
                body: JSON.stringify(subscriptionData)
              });
            case 3:
              response = _context.sent;
              _context.next = 6;
              return response.json();
            case 6:
              result = _context.sent;
              // if (result.gtLayer) {
              //   gtLayerPush(JSON.parse(result.gtLayer));
              // }

              if (result.success && result.url) {
                window.closeModal('subscribeModal');
                subscriptionBtn.classList.remove('disabled');
                subscriptionBtn.querySelector('i').classList.remove('spinner');
                if (result.url.includes('buy/subscription/success')) {
                  document.querySelector('#jsModal .header').innerHTML = 'Congratulations!!';
                  document.querySelector('#jsModal .body').innerHTML = '<br>You have successfully subscribed, <br> thanks for your support.';
                  window.openModal('jsModal', event);
                  window.location.href = result.url;
                } else {
                  window.location.href = result.url;
                }
              } else {
                erMsg = result.errors;
                window.showFormError(erMsg, subscriptionForm);
              }
              _context.next = 14;
              break;
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](0);
              _erMsg = ["Something went Wrong !"];
              window.showFormError(_erMsg, subscriptionForm);
            case 14:
              _context.prev = 14;
              subscriptionBtn.classList.remove('disabled');
              subscriptionBtn.querySelector('i').classList.remove('spinner');
              return _context.finish(14);
            case 18:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 10, 14, 18]]);
      }))();
    }
  });

  // Click Event for free Subscription
  var freeSubscription = document.getElementById('freeSubsBtn');
  if (freeSubscription) {
    freeSubscription.addEventListener('click', function (event) {
      event.preventDefault();
      var element = event.currentTarget;
      var id = element.getAttribute('data-id');
      var info = 'id=' + id;
      var freeSubsModal = document.getElementById('subscribeFree');
      freeSubscription.classList.add('disabled');
      freeSubscription.querySelector('i').classList.add('spinner');
      fetch(URL_BASE + '/subscription/free', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        },
        body: info
      }).then(function (response) {
        if (!response.ok) {
          throw new Error('Something went wrong!');
        }
        return response.json();
      }).then(function (result) {
        freeSubscription.classList.remove('disabled');
        freeSubscription.querySelector('i').classList.remove('spinner');
        if (result.success) {
          window.closeModal('subscribeModal');
          document.querySelector('#jsModal .header').innerHTML = 'Congratulations!!';
          document.querySelector('#jsModal .body').innerHTML = '<br>You have successfully subscribed, <br>thanks for your support.';
          window.openModal('jsModal', event);
          window.location.reload();
          document.getElementById('error').style.display = 'none';
        } else {
          var erMsg = [result.error];
          window.showFormError(erMsg, freeSubsModal);
          document.getElementById('showErrors').innerHTML = error;
          document.getElementById('error').style.display = 'block';
        }
      })["catch"](function (error) {
        var erMsg = ["Something went wrong!"];
        window.showFormError(erMsg, freeSubsModal);
        console.log(error);
      })["finally"](function () {
        freeSubscription.classList.remove('disabled');
        freeSubscription.querySelector('i').classList.remove('spinner');
      });
    });
  }
  //cancel subscription
  var subscriptionCancelBtn = document.getElementById("unsubscribeBtn");
  if (subscriptionCancelBtn) {
    subscriptionCancelBtn.addEventListener('click', function (e) {
      e.preventDefault();
      subscriptionCancelBtn.classList.add('disabled');
      subscriptionCancelBtn.querySelector('i').classList.add('spinner');
      var form = document.getElementById('formUnsubscribe');
      if (form) {
        subscriptionCancelBtn.classList.remove('disabled');
        subscriptionCancelBtn.querySelector('i').classList.remove('spinner');
        form.submit();
      }
    });
  }
};
module.exports = subscription;

},{}],13:[function(require,module,exports){
"use strict";

var timeAgoModule = function timeAgoModule() {
  function timeAgo(dateString) {
    var now = new Date();
    var date = new Date(dateString.replace(/-/g, '/'));
    var diff = Math.abs(now - date);
    var seconds = Math.floor(diff / 1000);
    var minutes = Math.floor(seconds / 60);
    var hours = Math.floor(minutes / 60);
    var days = Math.floor(hours / 24);
    var weeks = Math.floor(days / 7);
    var months = Math.floor(days / 30);
    var years = Math.floor(days / 365);
    if (seconds < 60) {
      return "".concat(seconds, " seconds ago");
    } else if (minutes == 1) {
      return "".concat(minutes, " minute ago");
    } else if (minutes <= 60) {
      return "".concat(minutes, " minutes ago");
    } else if (hours == 1) {
      return "".concat(hours, " hour ago");
    } else if (hours <= 24) {
      return "".concat(hours, " hours ago");
    } else if (days == 1) {
      return "".concat(days, " day ago");
    } else if (days <= 7) {
      return "".concat(days, " days ago");
    } else if (weeks == 1) {
      return "".concat(weeks, " week ago");
    } else if (weeks < 4 || weeks == 4 && days < 30) {
      return "".concat(weeks, " weeks ago");
    } else if (months == 1) {
      return "".concat(months, " month ago");
    } else if (months <= 12) {
      return "".concat(months, " months ago");
    } else if (years == 1) {
      return "".concat(years, " year ago");
    } else {
      return "".concat(years, " years ago");
    }
  }
  function updateTimeAgo() {
    var timeElements = document.querySelectorAll('.timeAgo');
    timeElements.forEach(function (element) {
      var timestamp = element.getAttribute('data');
      if (timestamp) {
        element.innerHTML = timeAgo(timestamp);
      }
    });
  }
  updateTimeAgo();

  // Use MutationObserver to watch for new elements
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          // Check if the added node is an element
          if (node.classList.contains('timeAgo')) {
            var timestamp = node.getAttribute('data');
            if (timestamp) {
              node.innerHTML = timeAgo(timestamp);
            }
          }

          // Check if there are any new timeAgo elements within the added node
          var timeElements = node.querySelectorAll('.timeAgo');
          timeElements.forEach(function (element) {
            var timestamp = element.getAttribute('data');
            if (timestamp) {
              element.innerHTML = timeAgo(timestamp);
            }
          });
        }
      });
    });
  });

  // Start observing the document body for added elements
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
};
module.exports = timeAgoModule;

},{}],14:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var updates = function updates() {
  var currentPlayer;
  var allPlayers = [];
  var editPost = document.querySelectorAll('.editPost');
  var deletePost = document.querySelectorAll('.deletePost');
  var pinnedPost = document.querySelectorAll('.pin-post');
  var deleteForm = document.querySelector('#postDeleteForm');
  var postUpdateForm = document.getElementById('postUpdateForm');
  var updatesJs = function updatesJs() {
    var observeMutations = function observeMutations(targetNode) {
      var config = {
        childList: true,
        subtree: true
      };
      var callback = function callback(mutationsList) {
        var _iterator = _createForOfIteratorHelper(mutationsList),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var mutation = _step.value;
            if (mutation.type === 'childList') {
              mutation.addedNodes.forEach(function (node) {
                if (node.nodeType === 1) {
                  var cntnt = node.querySelector('.cntnt') || node.classList.contains('cntnt') && node;
                  if (cntnt) {
                    initializeContent(cntnt);
                    var _updates = cntnt.closest('.updates');
                    if (_updates) {
                      var kebab = _updates.querySelector('.kebab');
                      var share = _updates.querySelector('.updates-share');
                      var bookmark = _updates.querySelector('.bookmarks');
                      var postShare = _updates.querySelector('.updates-share');
                      var editupdate = _updates.querySelector('.editPost');
                      var deleteupdate = _updates.querySelector('.deletePost');
                      var pinupdate = _updates.querySelector('.pinPost');
                      if (editupdate) {
                        editupdate.addEventListener('click', editPostPopup);
                      }
                      if (deleteupdate) {
                        deleteupdate.addEventListener('click', deletePostPopup);
                      }
                      if (pinupdate) {
                        pinupdate.addEventListener('click', pinPostPopup);
                      }
                      if (kebab) {
                        kebab.addEventListener('click', kebabsHandler);
                      }
                      if (share) {
                        share.addEventListener('click', sharePostHandler);
                      }
                      if (bookmark) {
                        bookmark.addEventListener('click', bookmarksHandler);
                      }
                      if (postShare) {
                        postShare.addEventListener('click', sharePostHandler);
                      }
                      var _lazyImages = _updates.querySelectorAll('img[loading="lazy"]');
                      if (_lazyImages.length > 0) {
                        _lazyImages.forEach(lazyload);
                      }
                    }
                  }
                }
              });
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      };
      var observer = new MutationObserver(callback);
      observer.observe(targetNode, config);
    };
    var kebabsHandler = function kebabsHandler(event) {
      var kebab = event.target;
      var kebabUpdates = kebab.closest('.updates');
      if (!kebabUpdates) {
        return;
      }
      var postId = kebabUpdates.getAttribute('data-id');
      var isBookmarked = kebabUpdates.getAttribute('data-isbookmarked');
      var isPinned = kebabUpdates.getAttribute('data-ispinned');
      var postUsername = kebabUpdates.getAttribute('data-username');
      var userName = kebabUpdates.getAttribute('data-name');
      var creatorId = kebabUpdates.getAttribute('data-creatorid');
      var modal = document.querySelector('#kebabListModal');
      var links = modal.querySelectorAll('.report, .bookmarks, .updates-share, .go-to-post, .unfollow-btn, .editPost, .deletePost, .pin-post');
      var description = kebabUpdates.getAttribute('data-desc');
      var price = kebabUpdates.getAttribute('data-price');
      var tagName = kebabUpdates.getAttribute('data-tagName');
      links.forEach(function (link) {
        link.setAttribute('data-id', postId);
        if (link.classList.contains('bookmarks')) {
          link.setAttribute('data-isBookmarked', isBookmarked);
        }
        if (link.classList.contains('pin-post')) {
          link.setAttribute('data-isPinned', isPinned);
          link.childNodes.forEach(function (node) {
            if (node.nodeType === Node.TEXT_NODE) {
              node.textContent = isPinned === '0' ? 'Pin to your profile' : 'Unpin from profile';
            }
          });
        }
        if (link.classList.contains('go-to-post') || link.classList.contains('updates-share')) {
          link.setAttribute('data-username', postUsername);
        }
        if (link.classList.contains('updates-share')) {
          link.setAttribute('data-name', userName);
        }
        if (link.classList.contains('unfollow-btn')) {
          link.setAttribute('data-user', creatorId);
          if (fc && fc.includes(parseInt(creatorId))) {
            link.classList.remove('hide');
          } else {
            link.classList.add('hide');
          }
        }
        if (link.classList.contains('editPost')) {
          link.setAttribute('data-desc', description);
          link.setAttribute('data-id', postId);
          link.setAttribute('data-price', price);
          link.setAttribute('data-tagName', tagName);
        }
        if (link.classList.contains('deletePost')) {
          link.setAttribute('data-id', postId);
        }
      });
      window.openModal('kebabListModal', postId, true);
    };
    var initializeContent = function initializeContent(cntnt) {
      var mediaLinks = cntnt.querySelectorAll('.media-link:not(.popup-content)');
      var popup = cntnt.querySelector('.img-popup');
      var body = document.body;
      if (!popup) {
        return;
      }
      var popupImg = popup.querySelector('.popup-img');
      var icons = popup.querySelector('.icons');
      var popupVideo = popup.querySelector('.popup-video');
      var videoSource = popupVideo.querySelector('source');
      var popupVideoSource = popupVideo.querySelector('source');
      var close = popup.querySelector('.close');
      var prev = popup.querySelector('.prev');
      var next = popup.querySelector('.next');
      var mediaImages = cntnt.querySelector('.mediaImages').value.split(',');
      var mediaVideos = cntnt.querySelector('.mediaVideos').value.split(',');
      var mediaTypes = cntnt.querySelector('.mediaTypes').value.split(',');
      var conversionStatus = cntnt.querySelector('.conversionStatus').value.split(',');
      var imagePath = cntnt.querySelector('.imagePath').value;
      var videoPath = cntnt.querySelector('.videoPath').value;
      var currentIndex;
      mediaLinks.forEach(function (link, index) {
        link.addEventListener('click', function (event) {
          event.stopPropagation();
          currentIndex = index;
          var type = link.querySelector('.pst-img');
          type = type && !type.classList.contains('image-poster') ? type.getAttribute('data-type') : 'video';
          var imagePoster = link.querySelector('.image-poster');
          if (type == 'image' && !imagePoster || mediaTypes.length > 1) {
            openPopup(currentIndex, type, cntnt);
          } else if (imagePoster || type == 'video') {
            var target = event.target;
            var hasIconsClass = target.classList.contains('icons');
            var closestIcon = target.parentElement && target.parentElement.classList.contains('icons') ? target.parentElement : null;
            if (hasIconsClass || closestIcon) {
              videoPlayer(event);
              if (hasIconsClass) {
                target.classList.add('hide');
              }
              if (closestIcon) {
                closestIcon.classList.add('hide');
              }
            }
          }
        });
      });
      close.addEventListener('click', function () {
        closePopup(popup, popupImg, popupVideo, popupVideoSource);
      });
      prev.addEventListener('click', function () {
        showPrev(cntnt);
      });
      next.addEventListener('click', function () {
        showNext(cntnt);
      });
      function openPopup(index, type, cntnt) {
        if (type === 'image') {
          popupImg.src = imagePath + mediaImages[index];
          var zoomImage = popupImg;
          zoomImage.addEventListener('click', handleZoom);
          zoomImage.addEventListener('touchend', handleZoom);
          zoomImage.addEventListener('mousemove', handleMove);
          zoomImage.addEventListener('touchmove', handleMove);
          popupVideo.classList.add('hide');
          var hlsPlayer = popupVideo.closest('.hlsjs-player');
          if (hlsPlayer) {
            hlsPlayer.classList.add('hide');
          }
          popupImg.classList.remove('hide');
          if (icons) {
            icons.classList.add('hide');
          }
        } else if (type === 'video') {
          var videoUrl = videoPath + mediaVideos[index];
          if (conversionStatus && conversionStatus[index] == 2) {
            videoUrl = videoUrl.replace(/\.[^/.]+$/, '.m3u8');
            videoSource.setAttribute('type', "application/x-mpegURL");
          } else {
            videoSource.removeAttribute('type');
          }
          popupVideo.setAttribute('data-src', videoUrl);
          videoSource.setAttribute('data-src', videoUrl);
          var _hlsPlayer = popupVideo.closest('.hlsjs-player');
          if (_hlsPlayer) {
            _hlsPlayer.classList.remove('hide');
          }
          if (currentPlayer) {
            if (conversionStatus && conversionStatus[index] == 2) {
              currentPlayer.src({
                src: videoUrl,
                type: 'application/x-mpegURL'
              });
            } else {
              currentPlayer.src({
                src: videoUrl
              });
            }
            currentPlayer.play();
          }
          popupVideo.classList.remove('hide');
          if (icons) {
            icons.classList.remove('hide');
          }
          popupImg.classList.add('hide');
          videoPlayer(popupVideo);
        }
        popup.classList.remove('hide');
        body.style.overflow = 'hidden';
        prev.style.display = index === 0 ? 'none' : 'block';
        next.style.display = index === mediaImages.length - 1 ? 'none' : 'block';
      }
      function closePopup(popup, popupImg, popupVideo, popupVideoSource) {
        if (currentPlayer) {
          currentPlayer.pause();
          currentPlayer.currentTime(0); // Reset playback to the start
          currentPlayer.src({});
        }
        popup.classList.add('hide');
        popupImg.src = "";
        popupImg.classList.add('hide');
        popupVideo.classList.add('hide');
        document.body.removeAttribute('style');
        if (icons) {
          icons.classList.add('hide');
        }
      }
      function showPrev(cntnt) {
        if (currentPlayer) {
          currentPlayer.pause();
          currentPlayer.currentTime(0); // Reset playback to the start
          currentPlayer.src({});
        }
        if (currentIndex > 0) {
          currentIndex--;
          var type = mediaTypes[currentIndex];
          openPopup(currentIndex, type, cntnt);
        }
      }
      function showNext(cntnt) {
        if (currentPlayer) {
          currentPlayer.pause();
          currentPlayer.currentTime(0); // Reset playback to the start
          currentPlayer.src({});
        }
        if (currentIndex < mediaImages.length - 1) {
          currentIndex++;
          var type = mediaTypes[currentIndex];
          openPopup(currentIndex, type, cntnt);
        }
      }
      function videoPlayer(event) {
        var eventTarget = event.target;
        if (!eventTarget) {
          eventTarget = event;
        }
        var mediaLink = eventTarget.closest('.media-link');
        if (mediaLink) {
          var imgPoster = mediaLink.querySelector('.image-poster');
          var videoEl = mediaLink.querySelector('video');
          var source = videoEl.querySelector('source');
          var src = source.getAttribute('data-src');
          videoEl.setAttribute('src', src);
          source.setAttribute('src', src);
          videoEl.classList.remove('hide');
          if (videoEl.classList.contains('loaded')) {
            currentPlayer = videojs.getPlayer(videoEl.parentElement.getAttribute('id'));
            currentPlayer.play();
          } else {
            var playerOptions = {};
            if (src.includes('.m3u8')) {
              playerOptions = {
                html5: {
                  vhs: {
                    overrideNative: true,
                    withCredentials: true
                  }
                }
              };
              source.setAttribute('type', 'application/x-mpegURL');
            } else {
              playerOptions = {};
            }
            var player = videojs(videoEl, playerOptions);
            var bigPlayButton = player.bigPlayButton.el();
            var controlBar = player.controlBar.el();
            videoEl.classList.add('loaded');
            videoEl.setAttribute('autoplay', true);
            if (imgPoster) {
              imgPoster.classList.add('hide');
            }
            player.on('pause', function () {
              bigPlayButton.style.display = "block";
              controlBar.style.display = "block";
            });
            player.on('ended', function () {
              bigPlayButton.style.display = "block";
              controlBar.style.display = "block";
            });
            player.on('play', function () {
              allPlayers.forEach(function (item) {
                if (item != player) {
                  item.pause();
                }
              });
              bigPlayButton.style.display = "none";
              controlBar.style.display = "block";
            });
            player.ready(function () {
              player.play()["catch"](function (error) {
                console.log(error);
              });
              var parentDiv = videoEl.parentElement;
              if (parentDiv) {
                var _controlBar = parentDiv.querySelector('.vjs-control-bar');
                if (_controlBar) {
                  _controlBar.style.display = "block";
                }
              }
            });
            var toggleControlBar = function toggleControlBar() {
              if (controlBar.style.display === "block") {
                controlBar.style.display = "none";
              } else {
                controlBar.style.display = "block";
              }
            };
            videoEl.addEventListener('click', toggleControlBar);
            videoEl.addEventListener('touchend', toggleControlBar);
            currentPlayer = player;
            allPlayers.push(currentPlayer);
          }
        }
      }
    };
    var contentPost = document.querySelectorAll('.cntnt');
    if (contentPost) {
      contentPost.forEach(initializeContent);
    }
    var kebabs = document.querySelectorAll('.kebab');
    if (kebabs) {
      kebabs.forEach(function (kebab) {
        kebab.addEventListener('click', kebabsHandler);
      });
    }
    observeMutations(document.body);
  };
  updatesJs();
  var isZoomed = false;
  var zoomLevel = 0;
  function handleZoom(e) {
    if (zoomLevel === 0) {
      e.target.style.transform = 'scale(2)';
      e.target.style.cursor = 'zoom-in';
      zoomLevel = 1;
    } else if (zoomLevel === 1) {
      e.target.style.transform = 'scale(3)';
      e.target.style.cursor = 'zoom-out';
      zoomLevel = 2;
    } else {
      e.target.style.transform = 'scale(1)';
      e.target.style.cursor = 'zoom-in';
      zoomLevel = 0;
    }
  }
  function handleMove(e) {
    if (zoomLevel > 0) {
      var rect = e.target.getBoundingClientRect();
      var x, y;
      if (e.touches) {
        x = (e.touches[0].pageX - rect.left - window.pageXOffset) / rect.width * 100;
        y = (e.touches[0].pageY - rect.top - window.pageYOffset) / rect.height * 100;
      } else {
        x = (e.pageX - rect.left - window.pageXOffset) / rect.width * 100;
        y = (e.pageY - rect.top - window.pageYOffset) / rect.height * 100;
      }
      e.target.style.transformOrigin = "".concat(x, "% ").concat(y, "%");
    }
  }
  document.addEventListener('click', function (e) {
    var likebutton = e.target.closest('.likeButton');
    if (likebutton) {
      if (e.target.closest('.likeButton')) {
        var id = likebutton.getAttribute('data-id');
        var data = new URLSearchParams({
          id: id
        });
        e.preventDefault();
        likebutton.blur();
        var _URL_BASE = window.location.origin;
        var csrfToken = document.getElementById('csrfToken').value;
        fetch(_URL_BASE + "/ajax/like", {
          method: 'POST',
          headers: {
            'X-CSRF-TOKEN': csrfToken,
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          body: data
        }).then(function (response) {
          return response.json();
        }).then(function (result) {
          if (result.success) {
            var sibling = likebutton.nextElementSibling;
            var element = likebutton;
            if (!sibling) {
              sibling = likebutton;
              element = likebutton.closest('div').querySelector('.svg');
            }
            sibling.innerHTML = result.total;
            replaceSrc(element, result.like);
            likebutton.classList.add('heart');
            setTimeout(function () {
              likebutton.classList.remove('heart');
            }, 600); // Remove class after animation duration
          } else {
            window.location.reload();
          }
        })["catch"](function (error) {
          console.log(error);
        });
      }
    }
  });

  // Bookmarks handler
  var bookmarksHandler = function bookmarksHandler(e) {
    e.preventDefault();
    var element = e.target.closest('.bookmarks');
    var id = element.getAttribute('data-id');
    var data = new URLSearchParams({
      id: id
    });
    var csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    fetch(URL_BASE + "/ajax/bookmark", {
      method: 'POST',
      headers: {
        'X-CSRF-TOKEN': csrfToken,
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: data
    }).then(function (response) {
      return response.json();
    }).then(function (result) {
      if (result.success) {
        if (result.type === 'deleted') {
          replaceSrc(element, false);
        } else if (result.type === 'added') {
          replaceSrc(element, true);
        }
        document.querySelector('#jsModal .header').innerHTML = 'Success!!';
        document.querySelector('#jsModal .body').innerHTML = 'Bookmark ' + (result.type === 'deleted' ? 'removed' : 'added') + ' successfully!';
      } else {
        document.querySelector('#jsModal .header').innerHTML = 'Failed!!';
        document.querySelector('#jsModal .body').innerHTML = 'Bookmark action failed!';
      }
      window.closeModal('kebabListModal');
      window.openModal('jsModal', e);
    })["catch"](function (error) {
      throw new Error('Failed to process bookmark action: ' + error.message);
    });
  };

  // Kebab Handler
  var kebabsHandler = function kebabsHandler(e) {
    e.preventDefault();
    var kebabUpdates = e.target.closest('.updates');
    var postId = kebabUpdates.getAttribute('data-id');
    var isBookmarked = kebabUpdates.getAttribute('data-is-bookmarked');
    var postUsername = kebabUpdates.getAttribute('data-username');
    var userName = kebabUpdates.getAttribute('data-name');
    var creatorId = kebabUpdates.getAttribute('data-creatorid');
    var modal = document.querySelector('#kebabListModal');
    var links = modal.querySelectorAll('.report, .bookmarks, .updates-share, .go-to-post, .unfollow-btn');
    links.forEach(function (link) {
      link.setAttribute('data-id', postId);
      if (link.classList.contains('bookmarks')) {
        link.setAttribute('data-isBookmarked', isBookmarked);
      }
      if (link.classList.contains('go-to-post') || link.classList.contains('updates-share')) {
        link.setAttribute('data-username', postUsername);
      }
      if (link.classList.contains('updates-share')) {
        link.setAttribute('data-name', userName);
      }
      if (link.classList.contains('unfollow-btn')) {
        link.setAttribute('data-user', creatorId);
        if (typeof fc != "undefined" && fc.includes(parseInt(creatorId))) {
          link.classList.remove('hide'); // Show the unfollow button
        } else {
          link.classList.add('hide'); // Hide the unfollow button if not following
        }
      }
    });
    window.openModal('kebabListModal', postId, true);
  };
  var viewPostHandler = function viewPostHandler(e) {
    e.preventDefault();
    window.closeModal('kebabListModal');
    var postUpdates = e.target.closest('.go-to-post');
    var postUsername = postUpdates.getAttribute('data-username');
    var postId = postUpdates.getAttribute('data-id');
    postUpdates.setAttribute('href', "".concat(URL_BASE, "/").concat(postUsername, "/post/").concat(postId));
    window.location.href = postUpdates.href;
  };
  var nextButton = document.querySelector('.next-btn');
  var backButton = document.querySelector('.back-btn');
  var submitButton = document.querySelector('.submit-btn');
  var currentResponseId = null;

  // Event listener for report handler
  var reportHandler = function reportHandler(e) {
    e.preventDefault();
    window.closeModal('kebabListModal');
    currentResponseId = e.target.dataset.id;
    var elementIds = ['report-form', 'report-next', 'report-update', 'message'];
    elementIds.forEach(function (id) {
      var previousElement = document.querySelector("[id^=".concat(id, "]"));
      if (previousElement) {
        previousElement.setAttribute('id', id); // Restore original ID
      }
    });
    elementIds.forEach(function (id) {
      var element = document.getElementById(id);
      if (element) {
        element.setAttribute('id', "".concat(id, "-").concat(currentResponseId));
      }
    });
    var reportForm = document.getElementById("report-form-".concat(currentResponseId));
    var reportNext = document.getElementById("report-next-".concat(currentResponseId));
    var reportUpdate = document.getElementById("report-update-".concat(currentResponseId));
    var textArea = document.getElementById("message-".concat(currentResponseId));

    // Initial button visibility
    if (backButton || submitButton) {
      backButton.classList.add('hide');
      submitButton.classList.add('hide');
      nextButton.classList.remove('hide');
    }

    // Update form action URL and classes
    reportForm.action = "/report/update/".concat(currentResponseId);
    nextButton.classList.add("next-btn-".concat(currentResponseId));
    backButton.classList.add("back-btn-".concat(currentResponseId));
    submitButton.classList.forEach(function (className) {
      if (className.startsWith('submit-btn-')) {
        submitButton.classList.remove(className);
      }
    });
    submitButton.classList.add("submit-btn-".concat(currentResponseId));
    reportNext.classList.remove('hide');
    reportUpdate.classList.add('hide');
    var errorcontainer = reportForm.querySelector('.formError');
    errorcontainer.style.display = 'none';
    errorcontainer.querySelector('.showFormErrors').innerHTML = '';
    window.openModal('reportPostModal', e, true);
  };

  // Event listener for "Next" button
  if (nextButton) {
    nextButton.addEventListener('click', function (e) {
      e.preventDefault();
      var textArea = document.getElementById("message-".concat(currentResponseId));
      var reportNext = document.getElementById("report-next-".concat(currentResponseId));
      var reportUpdate = document.getElementById("report-update-".concat(currentResponseId));
      if (textArea.value.length > 29) {
        reportNext.classList.add('hide');
        reportUpdate.classList.remove('hide');
        nextButton.classList.add('hide');
        backButton.classList.remove('hide');
        submitButton.classList.remove('hide');
        var errorcontainer = document.querySelector("#report-form-".concat(currentResponseId, " .formError"));
        errorcontainer.style.display = 'none';
        errorcontainer.querySelector('.showFormErrors').innerHTML = '';
      } else {
        var erMsg = {
          'error': "* Enter minimum 30 characters!"
        };
        window.showFormError(erMsg, document.getElementById("report-form-".concat(currentResponseId)));
      }
    });
  }

  // Event listener for "Back" button
  if (backButton) {
    backButton.addEventListener('click', function (e) {
      e.preventDefault();
      var reportNext = document.getElementById("report-next-".concat(currentResponseId));
      var reportUpdate = document.getElementById("report-update-".concat(currentResponseId));
      reportNext.classList.remove('hide');
      reportUpdate.classList.add('hide');
      nextButton.classList.remove('hide');
      backButton.classList.add('hide');
      submitButton.classList.add('hide');
      var errorcontainer = document.querySelector("#report-form-".concat(currentResponseId, " .formError"));
      errorcontainer.style.display = 'none';
      errorcontainer.querySelector('.showFormErrors').innerHTML = '';
    });
  }

  // Event listener for "Submit" button
  if (submitButton) {
    submitButton.addEventListener('click', function (e) {
      e.preventDefault();
      var form = e.target.closest('form');
      if (form) {
        var name = form.querySelector('.name').value;
        var email = form.querySelector('.email').value;
        var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        var isEmail = emailRegex.test(email);
        var errorcontainer = form.querySelector('.formError');
        errorcontainer.style.display = 'none';
        errorcontainer.querySelector('.showFormErrors').innerHTML = '';
        var messages = [];
        name === "" && messages.push("* Name must be filled out!");
        (email === "" || !isEmail) && messages.push("* Enter valid Email");
        if (messages.length > 0) {
          window.showFormError(messages, form);
          return; // Prevent form submission
        }
        handleFormSubmission(form);
      }
    });
  }

  // Function to handle form submission
  function handleFormSubmission(form) {
    fetch(form.getAttribute('action'), {
      method: 'POST',
      body: new FormData(form),
      headers: {
        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        'Accept': 'application/json'
      }
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      if (response.success) {
        document.querySelector('#jsModal .header').innerHTML = 'Thanks!!';
        document.querySelector('#jsModal .body').innerHTML = 'Your report has been received and will be reviewed. Thanks for making Bingeme a safer place!';
      } else if (response.errors) {
        document.querySelector('#jsModal .header').innerHTML = 'Oops!!';
        document.querySelector('#jsModal .body').innerHTML = 'Already sent a report';
      }
      window.closeModal('reportPostModal');
      document.getElementById("report-next-".concat(currentResponseId)).classList.remove('hide');
      document.getElementById("report-update-".concat(currentResponseId)).classList.add('hide');
      nextButton.classList.remove('hide');
      backButton.classList.add('hide');
      submitButton.classList.add('hide');
      window.openModal('jsModal');
      form.reset();
    })["catch"](function (error) {
      throw new Error('Failed to process report action: ' + error.message);
    });
  }
  var sharePostHandler = function sharePostHandler(e) {
    e.preventDefault();
    window.closeModal('kebabListModal');
    window.openModal('updatesShareSocialModal', e, true);
    var postUpdates = e.target.closest('.updates-share');
    var responseId = postUpdates.getAttribute('data-id');
    var postUsername = postUpdates.getAttribute('data-username');
    var userName = postUpdates.getAttribute('data-name');
    var baseUrl = window.location.origin;
    var postUrl = "".concat(baseUrl, "/").concat(postUsername, "/post/").concat(responseId);
    var modal = document.getElementById('updatesShareSocialModal');
    var urlMap = {
      'facebook.com': "https://www.facebook.com/sharer/sharer.php?u=".concat(postUrl),
      'twitter.com': "https://twitter.com/intent/tweet?url=".concat(postUrl, "&text=").concat(userName),
      'whatsapp://send': "whatsapp://send?text=".concat(postUrl),
      'mailto:': "mailto:?subject=".concat(userName, "&body=").concat(postUrl),
      'sms://': "sms://?body=Check this ".concat(postUrl)
    };
    modal.querySelectorAll('a').forEach(function (link) {
      var originalHref = link.getAttribute('href');
      Object.entries(urlMap).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        if (originalHref.includes(key)) {
          link.setAttribute('href', value);
          if (key === 'twitter.com') {
            link.setAttribute('data-url', postUrl);
          }
        }
      });
    });
    var copy_link = document.querySelector('#copy_post_link');
    if (copy_link) {
      copy_link.setAttribute('value', postUrl);
    }
    var linkShare = document.querySelector('.link-updates-share');
    if (linkShare) {
      linkShare.addEventListener('click', function () {
        window.copyToClipboard(copy_link.value);
        window.closeModal('profilesShareSocialModal');
        window.closeModal('updatesShareSocialModal');
        document.querySelector('#jsModal .header').innerHTML = 'SuccessFully!!';
        document.querySelector('#jsModal .body').innerHTML = 'Text copied to clipboard!!';
        window.openModal('jsModal');
      });
    }
  };
  var unfollowHandler = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
      var creatorId, profFollowIcon, proUnFollowIcon, response, data, allButtons, allFollowIcons, allUnfollowIcons, index, errorData;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            e.preventDefault();
            creatorId = e.target.getAttribute("data-user");
            profFollowIcon = document.querySelector(".prof-follow-icon[data-id=\"".concat(creatorId, "\"].follow"));
            proUnFollowIcon = document.querySelector(".prof-follow-icon[data-id=\"".concat(creatorId, "\"].un-follow"));
            _context.prev = 4;
            _context.next = 7;
            return fetch("".concat(URL_BASE, "/follow"), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
              },
              body: JSON.stringify({
                creator_id: creatorId,
                follow: "0"
              })
            });
          case 7:
            response = _context.sent;
            if (!response.ok) {
              _context.next = 25;
              break;
            }
            _context.next = 11;
            return response.json();
          case 11:
            data = _context.sent;
            document.querySelector('#jsModal .header').innerHTML = 'Success!!';
            document.querySelector('#jsModal .body').innerHTML = 'You unfollowed this creator';
            // Update all buttons with the same creator ID
            allButtons = document.querySelectorAll(".flw-".concat(creatorId));
            allButtons.forEach(function (btn) {
              btn.textContent = 'Follow';
              btn.classList.add('pri-btn');
              btn.classList.remove('sel-btn');
            });
            // Update follow and unfollow icons across the DOM
            allFollowIcons = document.querySelectorAll(".prof-follow-icon.follow[data-id=\"".concat(creatorId, "\"]"));
            allUnfollowIcons = document.querySelectorAll(".prof-follow-icon.un-follow[data-id=\"".concat(creatorId, "\"]"));
            allFollowIcons.forEach(function (icon) {
              icon.classList.remove('hide');
            });
            allUnfollowIcons.forEach(function (icon) {
              icon.classList.add('hide');
            });
            if (fc && Array.isArray(fc)) {
              index = fc.indexOf(parseInt(creatorId));
              if (index !== -1) {
                fc.splice(index, 1);
              }
            }
            // Update the individual modal buttons if they exist
            if (profFollowIcon) {
              profFollowIcon.classList.remove('hide');
            }
            if (proUnFollowIcon) {
              proUnFollowIcon.classList.add('hide');
            }
            _context.next = 30;
            break;
          case 25:
            _context.next = 27;
            return response.json();
          case 27:
            errorData = _context.sent;
            document.querySelector('#jsModal .header').innerHTML = 'Failed!!';
            document.querySelector('#jsModal .body').innerHTML = 'Failed to unfollow this creator';
          case 30:
            window.closeModal('profileShareModal');
            window.closeModal('kebabListModal');
            window.openModal('jsModal', e);
            _context.next = 38;
            break;
          case 35:
            _context.prev = 35;
            _context.t0 = _context["catch"](4);
            console.log(_context.t0);
          case 38:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[4, 35]]);
    }));
    return function unfollowHandler(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var unlockPostHandler = function unlockPostHandler(e) {
    if (!e.target.classList.contains('unlock')) {
      return;
    }
    var ppvModal = document.getElementById('ppvModal');
    var ppvModalBtn = document.getElementById('ppvModalBtn');
    var updates = e.target.closest('.updates');
    if (updates) {
      var errorcontainer = ppvModal.querySelector('.formError');
      if (errorcontainer) {
        errorcontainer.style.display = 'none';
        errorcontainer.querySelector('.showFormErrors').innerHTML = '';
      }
      if (ppvModalBtn) {
        ppvModalBtn.classList.remove('disabled');
        ppvModalBtn.querySelector('i').classList.remove('spinner');
      }
      var updateId = updates.dataset.id;
      var price = parseInt(updates.dataset.price);
      document.querySelector('#formSendPpv #sendPpvId').value = updateId;
      document.querySelector('#ppvModal #price').innerHTML = price;
      window.openModal('ppvModal');
      document.querySelector('#ppvModal .blk-btn').addEventListener('click', ppvHandler);
    }
  };
  var ppvHandler = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(e) {
      var modal, ppvModal, ppvModalBtn, errorcontainer, form, data, formData, _iterator2, _step2, _step2$value, key, value;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            e.preventDefault();
            modal = e.target.closest('.modal-container');
            ppvModal = document.getElementById('ppvModal');
            ppvModalBtn = document.getElementById('ppvModalBtn');
            ppvModalBtn.classList.add('disabled');
            ppvModalBtn.querySelector('i').classList.add('spinner');
            errorcontainer = ppvModal.querySelector('.formError');
            errorcontainer.style.display = 'none';
            errorcontainer.querySelector('.showFormErrors').innerHTML = '';
            if (!modal) {
              _context2.next = 17;
              break;
            }
            form = modal.querySelector('form');
            data = {};
            formData = new FormData(form);
            _iterator2 = _createForOfIteratorHelper(formData.entries());
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                _step2$value = _slicedToArray(_step2.value, 2), key = _step2$value[0], value = _step2$value[1];
                data[key] = value;
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
            _context2.next = 17;
            return fetch(form.action, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify(data)
            }).then(function (response) {
              return response.json();
            }).then(function (result) {
              ppvModalBtn.classList.remove('disabled');
              ppvModalBtn.querySelector('i').classList.remove('spinner');
              window.closeModal('ppvModal');
              if (result.errors) {
                var parentEl = document.querySelector('#ppvModal');
                window.showFormError(result.errors, parentEl);
              }
              if (result.success) {
                updateWalletAmount(result.wallet);
                if (result.url) {
                  window.location = result.url;
                }
                if (result.wallet) {
                  walletAmount = result.wallet;
                }
              }
            });
          case 17:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function ppvHandler(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
  var updateWalletAmount = function updateWalletAmount(walletAmount) {
    var walletAmountElements = document.querySelectorAll('.amountUpdate');
    walletAmountElements.forEach(function (element) {
      element.textContent = walletAmount;
    });
  };
  var bookmarks = document.querySelectorAll('.bookmarks');
  if (bookmarks) {
    bookmarks.forEach(function (bookmark) {
      bookmark.addEventListener('click', bookmarksHandler);
    });
  }

  //Report and Block
  var reportIcon = document.querySelector('.report');
  if (reportIcon) {
    reportIcon.addEventListener('click', reportHandler);
  }

  //Post Share
  var postShares = document.querySelectorAll('.updates-share');
  if (postShares.length > 0) {
    postShares.forEach(function (postShare) {
      postShare.addEventListener('click', sharePostHandler);
    });
  }

  //Post View
  var postView = document.querySelector('.go-to-post');
  if (postView) {
    postView.addEventListener('click', viewPostHandler);
  }

  //Unfollow Creators
  var unfollowCreator = document.querySelectorAll('.unfollow-btn');
  if (unfollowCreator) {
    unfollowCreator.forEach(function (button) {
      button.addEventListener('click', unfollowHandler);
    });
  }
  // Comments
  document.addEventListener('click', function (e) {
    var commentBtn = e.target.closest('.commentBtn');
    if (commentBtn) {
      var parent = commentBtn.closest('.updates');
      if (parent) {
        var commentsWrap = parent.querySelector('.comments-wrap');
        if (commentsWrap) {
          if (commentsWrap.style.display == 'block') {
            commentsWrap.style.display = 'none';
            return;
          }
        }
        var id = commentBtn.getAttribute('data-id');
        var form = parent.querySelector('.comments-form');
        if (form) {
          var hiddenInput = form.querySelector('input[name="update_id"]');
          hiddenInput.value = id;
        }
        var commentList = parent.querySelector('.comments-lst');
        e.preventDefault();
        if (commentList && commentList.children.length === 0) {
          commentBtn.blur();
          fetch("".concat(URL_BASE, "/loadmore/comments/v2?post=").concat(id), {
            method: 'GET'
          }).then(function (response) {
            return response.json();
          }).then(function (result) {
            if (result.comments) {
              var tempContainer = document.createElement('div');
              tempContainer.innerHTML = result.comments;

              // Append each child element to the comment list
              Array.from(tempContainer.children).forEach(function (child) {
                commentList.appendChild(child);
              });
            }
          })["catch"](function (error) {
            console.log(error);
          });
        }
        if (commentsWrap) {
          commentsWrap.style.display = 'block';
        }
      }
    }
  });
  document.addEventListener('submit', function (e) {
    if (e.target.matches('.comments-form')) {
      e.preventDefault();
      var form = e.target;
      var formData = new FormData(form);
      fetch(form.action, {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then(function (response) {
        return response.json();
      }).then(function (result) {
        if (result.success) {
          var commentsList = form.closest('.updates').querySelector('.comments-lst');
          commentsList.innerHTML += result.comment;
          form.reset();
        } else {
          // console.log(result.errors);
        }
      })["catch"](function (error) {
        console.log(error);
      });
    }
  });
  var handleLoadMoreComments = function handleLoadMoreComments(e) {
    var loadMoreComment = e.target.closest('.loadMoreComments');
    if (loadMoreComment) {
      var element = loadMoreComment;
      e.preventDefault();
      var container = loadMoreComment.closest('.comments-lst');
      var allElements = container.querySelectorAll('div.comments').length;
      var post = loadMoreComment.closest('.wrap-container').getAttribute('data-id');
      var wrapContainer = loadMoreComment.closest('.wrap-container');
      var loading = "Loading...";
      wrapContainer.innerHTML = "<a href=\"javascript:void(0)\">\u2014 ".concat(loading, "</a>");
      element.blur();
      fetch("".concat(URL_BASE, "/loadmore/comments/v2?post=").concat(post, "&skip=").concat(allElements), {
        method: 'GET'
      }).then(function (response) {
        return response.json();
      }).then(function (result) {
        if (result.comments) {
          wrapContainer.innerHTML = '';
          var tempContainer = document.createElement('div');
          tempContainer.innerHTML = result.comments;

          //Insert All the comments first in Order
          Array.from(tempContainer.children).forEach(function (child) {
            if (child.classList.contains('comments')) {
              wrapContainer.parentNode.insertBefore(child, wrapContainer.nextSibling);
            }
          });

          //After Inserting Comments, Appends Loadmore button after the comments
          Array.from(tempContainer.children).forEach(function (child) {
            if (child.classList.contains('wrap-container')) {
              container.append(child);
            }
          });
          wrapContainer.remove();
        }
      })["catch"](function (error) {
        console.log(error);
      });
    }
  };
  var deletePostComments = function deletePostComments(e) {
    var delComment = e.target.closest('.del-cmnt');
    if (delComment) {
      e.preventDefault();
      var element = delComment;
      var cmtId = delComment.getAttribute('data-id');
      var csrfToken = document.getElementById('csrfToken').value;
      element.blur();
      fetch("".concat(URL_BASE, "/ajax/delete-comment/").concat(cmtId), {
        method: 'POST',
        headers: {
          'X-CSRF-TOKEN': csrfToken,
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (response) {
        return response.json();
      }).then(function (result) {
        if (result.success) {
          var totCmnts = document.querySelector(".tot-cmnts-".concat(cmtId));
          var commentElement = element.closest('.comments');
          if (commentElement) {
            commentElement.style.transition = 'opacity 0.4s ease';
            commentElement.style.opacity = 0;
            setTimeout(function () {
              commentElement.remove();
              if (totCmnts) {
                totCmnts.innerHTML = result.total;
              }
            }, 400);
          }
        }
      })["catch"](function (error) {
        console.log(error);
      });
    }
  };
  var likePostComments = function likePostComments(e) {
    var likeComment = e.target.closest('.like-cmnt');
    if (likeComment) {
      e.preventDefault();
      var cmtId = likeComment.getAttribute('data-id');
      var csrfToken = document.getElementById('csrfToken').value;
      likeComment.blur();
      var data = new URLSearchParams({
        comment_id: cmtId
      });
      fetch("".concat(URL_BASE, "/comment/like"), {
        method: 'POST',
        headers: {
          'X-CSRF-TOKEN': csrfToken,
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: data
      }).then(function (response) {
        return response.json();
      }).then(function (result) {
        if (result.success) {
          var totCmnts = document.querySelector(".tot-like-cmnt-".concat(cmtId));
          var img = likeComment.querySelector('img');
          if (totCmnts) {
            totCmnts.innerHTML = result.count > 0 ? result.count : '';
          }
          if (result.type === 'like') {
            replaceSrc(img, true);
          } else if (result.type === 'unlike') {
            replaceSrc(img, false);
          }
          img.classList.add('heart');
          setTimeout(function () {
            img.classList.remove('heart');
          }, 600); // Remove class after animation duration
        }
      })["catch"](function (error) {
        console.log(error);
      });
    }
  };
  var tipPostHandler = function tipPostHandler(e) {
    var closestDiv = e.target.closest('div');
    if (!e.target.classList.contains('update-tip') && (!closestDiv || !closestDiv.classList.contains('update-tip'))) {
      return;
    }
    e.preventDefault();
    var updates = e.target.closest('.updates');
    if (updates) {
      var modal = document.querySelector('#tipModal');
      var url = STATIC_URL + '/' + updates.dataset.username;
      modal.querySelector('.info').setAttribute('href', url);
      var profileImage = modal.querySelector('.info .tip-modal-prfl img');
      var profileImageSrc = updates.querySelector('.profile-pic img');
      profileImage.setAttribute('src', profileImageSrc.getAttribute('src'));
      modal.querySelector('.cName').innerHTML = updates.dataset.name;
      modal.querySelector('.userName').innerHTML = '@' + updates.dataset.username;
      modal.querySelector('#tipModal #id').value = updates.dataset.creatorid;
      window.openModal('tipModal');
    }
  };
  // Function to handle "load more comments" functionality
  document.addEventListener('click', handleLoadMoreComments);

  // Function to handle "Delete comments" functionality
  document.addEventListener('click', deletePostComments);

  // Function to handle "Like comments" functionality
  document.addEventListener('click', likePostComments);

  // Function to handle "Unlock content" functionality
  document.addEventListener('click', unlockPostHandler);

  // Function to handle "Tip content" functionality
  document.addEventListener('click', tipPostHandler);

  // Create a single instance of EmojiButton
  var picker = new EmojiButton({
    autoHide: false
  });
  var currentInput = null;

  // Handle the emoji selection event
  picker.on('emoji', function (emoji) {
    if (currentInput) {
      currentInput.value += emoji;
    }
  });

  // Function to adjust the position of the emoji picker
  var adjustPickerPosition = function adjustPickerPosition(button) {
    var buttonRect = button.getBoundingClientRect();
    var scrollY = window.scrollY;
    var scrollX = window.scrollX;
    var windowHeight = window.innerHeight;
    var windowWidth = window.innerWidth;
    var pickerHeight = 300; // Assuming the picker height to be 300px

    var top = buttonRect.bottom + 10 + scrollY; // Move 10px below the button
    var left = buttonRect.left + scrollX;

    // Adjust if picker would go off screen
    if (buttonRect.bottom + pickerHeight + 10 > windowHeight) {
      top = buttonRect.top - pickerHeight - 10 + scrollY; // Move 10px above the button
    }
    if (windowWidth < 355) {
      left -= 40;
    }

    // Set the picker position
    var pickerEl = document.querySelector('.emoji-picker');
    // const pickerEl = pickerElWrap.closest('.wrapper');

    if (pickerEl) {
      pickerEl.style.position = 'absolute';
      pickerEl.style.top = "".concat(top, "px");
      pickerEl.style.left = "".concat(left, "px");
      pickerEl.style.zIndex = 9999;
    }
  };

  // Event delegation to handle clicks on dynamically added emoji buttons
  document.addEventListener('click', function (e) {
    var button = e.target.closest('#emoji-button');
    if (button) {
      e.preventDefault();
      e.stopPropagation();
      var form = button.closest('.comments-form');
      // Find the corresponding comment input field within the same post
      if (form) {
        currentInput = form.querySelector('input[name="comment"]');
      }
      picker.togglePicker(button);
      adjustPickerPosition(button);
    }
  });

  // Function to handle sending a comment
  var sendCommentHandler = function sendCommentHandler(form) {
    var commentInput = form.querySelector('input[name="comment"]');
    var hiddenInput = form.querySelector('input[name="update_id"]');
    var id = hiddenInput.value;
    var commentVal = commentInput.value;
    var commentswrap = form.closest('.comments-wrap');
    var container = commentswrap.querySelector('.comments-lst');
    var errorcontainer = commentswrap.querySelector('.formError');
    errorcontainer.style.display = 'none';
    errorcontainer.querySelector('.showFormErrors').innerHTML = '';
    if (commentVal === '') {
      return;
    }
    var data = new URLSearchParams({
      update_id: id,
      comment: commentVal
    });
    var csrfToken = document.getElementById('csrfToken').value;
    fetch(form.action, {
      method: 'POST',
      headers: {
        'X-CSRF-TOKEN': csrfToken,
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: data
    }).then(function (response) {
      return response.json();
    }).then(function (result) {
      if (result.success) {
        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = result.comment.trim();
        container.insertBefore(tempDiv.firstElementChild, container.firstChild);
        container.scrollTop = 0;
        commentInput.value = '';
      } else if (result.errors) {
        window.showFormError(result.errors, commentswrap);
      }
    })["catch"](function (error) {
      console.log(error);
    });
  };

  // Event listener for the send button click
  document.addEventListener('click', function (e) {
    if (e.target.closest('.send-cmnt')) {
      e.preventDefault();
      var commentform = e.target.closest('.comments-form');
      if (commentform) {
        sendCommentHandler(commentform);
      }
    }
  });

  // Event listener for pressing Enter in the comment input field
  document.addEventListener('keypress', function (e) {
    if (e.target.closest('.send-cmnt')) {
      if (e.key === 'Enter') {
        e.preventDefault();
        var commentform = e.target.closest('.comments-form');
        if (commentform) {
          sendCommentHandler(commentform);
        }
      }
    }
  });
  var lazyImages = document.querySelectorAll('img[loading="lazy"]');
  if (lazyImages.length > 0) {
    lazyImages.forEach(lazyload);
  }
  function lazyload(image) {
    var imageObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var lazyImage = entry.target;
          lazyImage.src = lazyImage.dataset.src;
          lazyImage.onload = function () {
            lazyImage.removeAttribute("data-src");
            lazyImage.removeAttribute("loading");
          };
          lazyImage.onerror = function () {
            console.error('Error loading image:', lazyImage.dataset.src);
          };
          observer.unobserve(lazyImage);
        }
      });
    });
    imageObserver.observe(image);
  }
  var editPostPopup = function editPostPopup(e) {
    var targetEvent = e.target.classList.contains('editPost') ? e.target : e.target.closest('.editPost');
    window.closeModal('kebabListModal');
    window.openModal('postEdit', null, true);
    if (postUpdateForm) {
      postUpdateForm.style.display = "block";
      postUpdateForm.querySelector('.error-div').classList.add('hide');
    }
    var id = targetEvent.getAttribute('data-id');
    var desc = targetEvent.getAttribute('data-desc');
    var price = targetEvent.getAttribute('data-price');
    var modalDiv = document.getElementById('postEdit');
    var descTextArea = modalDiv.querySelector('.textareaAutoSize');
    var priceDiv = modalDiv.querySelector('.price');
    var idInput = modalDiv.querySelector('.uId');
    descTextArea.value = desc;
    idInput.value = id;
    priceDiv.value = Math.floor(price);
    var tagList = targetEvent.getAttribute('data-tagName');
    var tagInput = postUpdateForm.querySelector('.update_tags');
    if (tagList && tagInput) {
      tagInput.value = " ".concat(tagList.replace(/,/g, ''));
    }
  };
  var deletePostPopup = function deletePostPopup(e) {
    e.preventDefault();
    var targetEvent = e.target.classList.contains('deletePost') ? e.target : e.target.closest('.deletePost');
    window.closeModal('kebabListModal');
    if (deleteForm) {
      var deletePostId = targetEvent.getAttribute('data-id');
      deleteForm.querySelector('.uId').value = deletePostId;
    }
    window.openModal('postDelete', null, true);
  };
  var pinPostPopup = function pinPostPopup(e) {
    e.preventDefault();
    var parent = document.querySelector('.updates');
    var element = e.target.closest('.pin-post');
    var id = element.getAttribute('data-id');
    var data = new URLSearchParams({
      id: id
    });
    element.blur();
    fetch("".concat(URL_BASE, "/pin/post"), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      },
      body: data.toString()
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      if (response.success !== false) {
        var isPinned = response.status === 'pin';
        if (isPinned) {
          parent.classList.add('pinned');
        } else {
          parent.classList.remove('pinned');
        }
        document.querySelector('#jsModal .header').innerHTML = 'Success!!';
        document.querySelector('#jsModal .body').innerHTML = "Post ".concat(isPinned ? 'pinned' : 'unpinned', " successfully!");
        window.closeModal('kebabListModal');
        window.openModal('jsModal', e);
        window.location.reload();
      }
    })["catch"](function () {
      console.error('An error occurred while processing the request.');
    });
    window.closeModal('kebabListModal');
  };
  if (deleteForm) {
    deleteForm.addEventListener('submit', /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(e) {
        var formData, updateId, url, response, result, updatesDiv;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              e.preventDefault();
              formData = new FormData(this);
              updateId = deleteForm.querySelector('.uId').value;
              url = "".concat(this.action, "/").concat(updateId);
              _context3.prev = 4;
              _context3.next = 7;
              return fetch(url, {
                method: 'POST',
                body: formData,
                headers: {
                  'X-Requested-With': 'XMLHttpRequest'
                }
              });
            case 7:
              response = _context3.sent;
              if (!response.ok) {
                _context3.next = 15;
                break;
              }
              _context3.next = 11;
              return response.json();
            case 11:
              result = _context3.sent;
              if (result.success) {
                updatesDiv = document.querySelector(".updates[data-id=\"".concat(updateId, "\"]"));
                if (updatesDiv) {
                  updatesDiv.remove();
                }
                window.closeModal('postDelete');
                document.querySelector('#jsModal .header').innerHTML = 'Success!!';
                document.querySelector('#jsModal .body').innerHTML = 'Post deleted successfully!';
                window.openModal('jsModal', e);
              }
              _context3.next = 16;
              break;
            case 15:
              console.error('Form submission failed:', response.statusText);
            case 16:
              _context3.next = 21;
              break;
            case 18:
              _context3.prev = 18;
              _context3.t0 = _context3["catch"](4);
              console.error('An error occurred:', _context3.t0);
            case 21:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[4, 18]]);
      }));
      return function (_x3) {
        return _ref5.apply(this, arguments);
      };
    }());
  }
  if (editPost) {
    editPost.forEach(function (edit) {
      edit.addEventListener('click', editPostPopup);
    });
  }
  if (deletePost) {
    deletePost.forEach(function (del) {
      del.addEventListener('click', deletePostPopup);
    });
  }
  if (pinnedPost) {
    pinnedPost.forEach(function (pin) {
      var isPinned = pin.getAttribute('data-ispinned');
      pin.addEventListener('click', pinPostPopup);
    });
  }
  var tagAppend = function tagAppend(e) {
    if (e.target.classList.contains('notAdded')) {
      e.target.classList.add('sel-btn');
      e.target.classList.remove('notAdded');
      var tagInput = postUpdateForm.querySelector('.update_tags');
      tagInput.value += " ".concat(e.target.innerHTML);
    }
  };
  if (postUpdateForm) {
    var priceTag = postUpdateForm.querySelector('.price-tag.popup');
    if (priceTag) {
      priceTag.addEventListener('click', function (e) {
        e.preventDefault();
        var priceWrapPopup = postUpdateForm.querySelector('.price-wrap-popup');
        priceWrapPopup.classList.toggle('hide');
      });
    }
    var tagButtons = postUpdateForm.querySelectorAll('.tag-btn.notAdded');
    if (tagButtons) {
      tagButtons.forEach(function (tagButton) {
        tagButton.addEventListener('click', tagAppend);
      });
    }
    postUpdateForm.addEventListener('submit', /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(e) {
        var lockOpen, locked, data, formData, updateId, response, result, updatesDiv, price, colorSpan, src, globe, lock, priceDivSpan, className, iconHtml, priceHtml, errorsObj, errorDiv;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              e.preventDefault();
              lockOpen = postUpdateForm.querySelector('.lock-open').classList.contains('hide');
              locked = false;
              if (lockOpen) {
                locked = true;
              }
              data = {};
              data['locked'] = locked;
              formData = new FormData(this);
              formData.append('locked', locked);
              updateId = postUpdateForm.querySelector('.uId').value;
              _context4.prev = 9;
              _context4.next = 12;
              return fetch(this.action, {
                method: 'POST',
                body: formData,
                headers: {
                  'X-Requested-With': 'XMLHttpRequest'
                }
              });
            case 12:
              response = _context4.sent;
              if (!response.ok) {
                _context4.next = 20;
                break;
              }
              _context4.next = 16;
              return response.json();
            case 16:
              result = _context4.sent;
              if (result.success) {
                updatesDiv = document.querySelector(".updates[data-id=\"".concat(updateId, "\"]"));
                if (updatesDiv) {
                  updatesDiv.querySelector('.caption').innerHTML = result.description;
                  price = updatesDiv.querySelector('.price-listing');
                  updatesDiv.setAttribute('data-desc', result.description);
                  updatesDiv.setAttribute('data-tagname', result.tags);
                  updatesDiv.setAttribute('data-price', Number(result.price.replace(/,/g, '')));
                  if (price && result.price > 0) {
                    price.innerHTML = result.price;
                  } else {
                    colorSpan = updatesDiv.querySelector('.pr-dtl');
                    src = colorSpan.getAttribute('data-src');
                    globe = updatesDiv.querySelector('.globe');
                    lock = updatesDiv.querySelector('.lock');
                    if (lock) lock.remove();
                    if (globe) globe.remove();
                    priceDivSpan = colorSpan.querySelector('.color');
                    if (priceDivSpan) {
                      priceDivSpan.remove();
                    }
                    className = result.locked == 'yes' ? 'lock' : 'globe';
                    iconHtml = "<img src=\"".concat(src + className + '.svg', "\" class=\"").concat(className, "\" width=\"12\" height=\"12\" />");
                    priceHtml = "<span class=\"d-inflex al-c txt-tags color\"><img src=\"".concat(src + 'coin.svg', "\" class=\"\" width=\"14px\" height=\"14px\" />\n                  <span class=\"price-listing\">").concat(result.price, "</span></span>");
                    if (colorSpan) {
                      colorSpan.innerHTML += iconHtml;
                      if (parseInt(result.price) > 0) {
                        colorSpan.innerHTML += priceHtml;
                      }
                    }
                  }
                }
                window.closeModal('postEdit');
                document.querySelector('#jsModal .header').innerHTML = 'Success!!';
                document.querySelector('#jsModal .body').innerHTML = 'Post updated successfully!';
                window.openModal('jsModal', e);
              } else {
                errorsObj = Object.keys(result.errors);
                errorDiv = postUpdateForm.querySelector('.error-div');
                errorDiv.innerHTML = '';
                errorDiv.classList.remove('hide');
                errorsObj.forEach(function (key) {
                  var errors = result.errors[key];
                  if (Array.isArray(errors)) {
                    errors.forEach(function (err) {
                      errorDiv.innerHTML += "<li>".concat(err, "</li>");
                      console.log(err);
                    });
                  }
                });
              }
              _context4.next = 21;
              break;
            case 20:
              console.error('Form submission failed:', response.statusText);
            case 21:
              _context4.next = 26;
              break;
            case 23:
              _context4.prev = 23;
              _context4.t0 = _context4["catch"](9);
              console.error('An error occurred:', _context4.t0);
            case 26:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[9, 23]]);
      }));
      return function (_x4) {
        return _ref6.apply(this, arguments);
      };
    }());
  }
};
module.exports = updates;

},{}],15:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var userActiveStatus = function userActiveStatus() {
  var activeStatusOnline = document.querySelectorAll(".active-status-online");
  var socket = window.socket;
  var emitActiveStatus = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(activeStatusOnline) {
      var userIds;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            try {
              userIds = Array.from(activeStatusOnline).map(function (element) {
                return element.getAttribute('data-user-id');
              });
              socket.emit('usersActiveStatus', userIds, function (response) {});
            } catch (error) {
              console.error("Error during emitActiveStatus:", error);
            }
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function emitActiveStatus(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  if (socket) {
    socket.on('StatusActive', function (userIds) {
      activeStatusOnline.forEach(function (event) {
        var userId = event.getAttribute('data-user-id');
        var isUserActive = userIds.some(function (id) {
          return id == userId;
        });
        var activeImg = event.querySelectorAll('.active-' + userId);
        var notActiveImg = event.querySelectorAll('.not-active-' + userId);
        if (isUserActive) {
          activeImg.forEach(function (img) {
            return img.classList.remove('hide');
          });
          notActiveImg.forEach(function (img) {
            return img.classList.add('hide');
          });
        } else {
          activeImg.forEach(function (img) {
            return img.classList.add('hide');
          });
          notActiveImg.forEach(function (img) {
            return img.classList.remove('hide');
          });
        }
      });
    });
    socket.on('UserOffline', function (data) {
      var activeDot = document.querySelectorAll(".active-".concat(data.userId));
      var notActiveDot = document.querySelectorAll(".not-active-".concat(data.userId));
      if (activeDot) {
        activeDot.forEach(function (dot) {
          return dot.classList.add('hide');
        });
      }
      if (notActiveDot) {
        notActiveDot.forEach(function (dot) {
          return dot.classList.remove('hide');
        });
      }
    });
    socket.on('UserOnline', function (data) {
      var activeDot = document.querySelectorAll(".active-".concat(data.userId));
      var notActiveDot = document.querySelectorAll(".not-active-".concat(data.userId));
      if (activeDot) {
        activeDot.forEach(function (dot) {
          return dot.classList.remove('hide');
        });
      }
      if (notActiveDot) {
        notActiveDot.forEach(function (dot) {
          return dot.classList.add('hide');
        });
      }
    });
  }
  var observeMutations = function observeMutations(targetNode) {
    var config = {
      childList: true,
      subtree: true
    };
    var callback = function callback(mutationsList) {
      var updated = false;
      var _iterator = _createForOfIteratorHelper(mutationsList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var mutation = _step.value;
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach(function (node) {
              if (node.nodeType === 1) {
                var statusDiv = node.querySelector('.active-status-online') || node.classList.contains('active-status-online') && node;
                if (statusDiv) {
                  updated = true;
                }
              }
            });
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (updated) {
        activeStatusOnline = document.querySelectorAll(".active-status-online");
        emitActiveStatus(activeStatusOnline);
      }
    };
    var observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  };
  observeMutations(document.body);
};
module.exports = userActiveStatus;

},{}],16:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var videoCallPurchase = function videoCallPurchase() {
  var getCamera = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var stream;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return navigator.mediaDevices.getUserMedia({
              video: true,
              audio: true
            });
          case 3:
            stream = _context.sent;
            stream.getTracks().forEach(function (track) {
              return track.stop();
            });
            return _context.abrupt("return", true);
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            console.error("Permissions denied or an error occurred: ", _context.t0);
            return _context.abrupt("return", false);
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 8]]);
    }));
    return function getCamera() {
      return _ref.apply(this, arguments);
    };
  }();
  var videoCallPay = document.querySelector('#videoCallPay');
  var checkPermissions = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(e) {
      var fiveMinPrice, perMinPrice, errorContainer, showErrors, permissionGranted, _payButton, _errorContainer, _showErrors;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            e.preventDefault();

            //Check for Sufficient Balance in User Wallet
            fiveMinPrice = Number(document.querySelector('.video-call').getAttribute('data-fiveMinPrice'));
            perMinPrice = Number(document.querySelector('.video-call').getAttribute('data-perMinPrice'));
            if (videoCallPay) {
              errorContainer = videoCallPay.querySelector('.formError');
              if (errorContainer) {
                showErrors = errorContainer.querySelector('.showFormErrors');
                showErrors.innerHTML = '';
                errorContainer.style.display = 'none';
              }
            }

            //Check for Camera/Mic permission
            _context2.next = 6;
            return getCamera();
          case 6:
            permissionGranted = _context2.sent;
            if (permissionGranted) {
              _context2.next = 10;
              break;
            }
            showModal(e, "Allow Camera and Microphone Permissons !!");
            return _context2.abrupt("return");
          case 10:
            document.querySelectorAll('.price-amount').forEach(function (element) {
              element.textContent = perMinPrice;
            });
            document.querySelectorAll('.total-amount').forEach(function (element) {
              element.textContent = fiveMinPrice;
            });
            if (walletAmount < fiveMinPrice) {
              _payButton = document.getElementById('payModalBtn');
              _payButton.classList.add('disabled');
              _errorContainer = videoCallPay.querySelector('.formError');
              if (_errorContainer) {
                _showErrors = _errorContainer.querySelector('.showFormErrors');
                _showErrors.innerHTML = '<li>Insufficient balance to make video call !<li>';
                _errorContainer.style.display = 'block';
              }
            }
            window.openModal('videoCallPay', e);
          case 14:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function checkPermissions(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  // If user click the payButton, then call the handlePayment function
  var payButton = document.getElementById('payModalBtn');
  if (payButton) {
    payButton.addEventListener('click', /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(e) {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return handlePayment(e);
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }());
  }
  var handlePayment = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(e) {
      var payButton, errorContainer, showErrors, icon, response, data, userId, creatorId, roomId, userDetails, stopPlayback, videoCallAlertOff;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            payButton = document.getElementById('payModalBtn');
            errorContainer = videoCallPay.querySelector('.formError');
            if (errorContainer) {
              showErrors = errorContainer.querySelector('.showFormErrors');
              showErrors.innerHTML = '';
              errorContainer.style.display = 'none';
            }
            icon = document.createElement('i');
            icon.classList.add('spinner');
            payButton.classList.add('disabled');
            payButton.appendChild(icon);
            _context4.prev = 7;
            _context4.next = 10;
            return fetch("".concat(URL_BASE, "/video/call/payment/").concat(profile_id), {
              method: 'GET',
              headers: {
                'Accept': 'application/json'
              }
            });
          case 10:
            response = _context4.sent;
            _context4.next = 13;
            return response.json();
          case 13:
            data = _context4.sent;
            if (!(data.success && data.url)) {
              _context4.next = 22;
              break;
            }
            userId = data.userId, creatorId = data.creatorId, roomId = data.roomId, userDetails = data.userDetails, stopPlayback = data.stopPlayback, videoCallAlertOff = data.videoCallAlertOff;
            _context4.next = 18;
            return socket.emit('call-user', {
              userId: userId,
              recipientId: creatorId,
              roomId: roomId,
              userDetails: userDetails,
              stopPlayback: stopPlayback,
              videoCallAlertOff: videoCallAlertOff
            });
          case 18:
            window.closeModal('videoCallPay');
            window.location = data.url;
            _context4.next = 25;
            break;
          case 22:
            window.closeModal('videoCallPay');
            showModal(e, data.message);
            return _context4.abrupt("return");
          case 25:
            _context4.next = 32;
            break;
          case 27:
            _context4.prev = 27;
            _context4.t0 = _context4["catch"](7);
            window.closeModal('videoCallPay');
            showModal(e, 'An error occurred, please try again.');
            throw new Error('Video call permissions error: ' + JSON.stringify(_context4.t0));
          case 32:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[7, 27]]);
    }));
    return function handlePayment(_x3) {
      return _ref4.apply(this, arguments);
    };
  }();
  var videoCallButton = document.querySelector('.video-call');
  if (videoCallButton) {
    videoCallButton.addEventListener('click', checkPermissions);
  }
  var showModal = function showModal(e, body) {
    document.querySelector('#jsModal .header').innerHTML = '';
    document.querySelector('#jsModal .close').classList.add('hide');
    document.querySelector('#jsModal .videoCall-close').classList.remove('hide');
    var modalContent = "".concat(body, "<br><a class=\"mt-20 sml-btn blk-btn cancel-js-modal\">Cancel</a>");
    document.querySelector('#jsModal .body').innerHTML = modalContent;
    document.querySelector('#jsModal .body').classList.add('jsModalBody');
    window.openModal('jsModal', e);
    document.querySelector('.cancel-js-modal').addEventListener('click', function () {
      window.closeModal('jsModal');
    });
  };
};
module.exports = videoCallPurchase;

},{}],17:[function(require,module,exports){
"use strict";

var follow = require('../components/_follow');
var refresh = require('../components/_refresh');
var layout = require('../components/_layout');
var profile = require('../components/_profile');
var modalTip = require('../components/_modal-tip');
var updates = require('../components/_updates');
var timeago = require('../components/_timeAgo');
var subscription = require('../components/_subscription');
var modalPrebook = require('../components/_modal-prebook');
var reportUsers = require('../components/_reportUsers');
var liveStoryTimer = require('../components/_liveStoryTimer');
var livePermission = require('../components/_live-permission');
var liveStoryForm = require('../components/_modal-liveStory');
var product_buying = require('../components/_product-buying');
var videoCallPurchase = require('../components/_video-call-purchase');
var userActiveStatus = require('../components/_user-active-status');
document.addEventListener('DOMContentLoaded', function () {
  layout();
  follow();
  refresh();
  profile();
  modalTip();
  updates();
  timeago();
  subscription();
  liveStoryForm();
  modalPrebook();
  reportUsers();
  liveStoryTimer();
  livePermission();
  product_buying();
  videoCallPurchase();
  userActiveStatus();
});

},{"../components/_follow":1,"../components/_layout":2,"../components/_live-permission":3,"../components/_liveStoryTimer":4,"../components/_modal-liveStory":5,"../components/_modal-prebook":6,"../components/_modal-tip":7,"../components/_product-buying":8,"../components/_profile":9,"../components/_refresh":10,"../components/_reportUsers":11,"../components/_subscription":12,"../components/_timeAgo":13,"../components/_updates":14,"../components/_user-active-status":15,"../components/_video-call-purchase":16}]},{},[17]);
